export const merchantCategoryCode = {
  '0742': 'Veterinary Services',
  '0763': 'Agricultural Co-operatives',
  '0780': 'Horticultural Services, Landscaping Services',
  1520: 'General Contractors - Residential and Commercial',
  1711: 'Air Conditioning Contractors - Sales and Installation, Heating Contractors - Sales, Service, Installation',
  1731: 'Electrical Contractors',
  1740: 'Insulation - Contractors, Masonry, Stonework Contractors, Plastering Contractors, Stonework and Masonry Contractors, Tile Settings Contractors',
  1750: 'Carpentry Contractors',
  1761: 'Roofing - Contractors, Sheet Metal Work - Contractors, Siding - Contractors',
  1771: 'Contractors - Concrete Work',
  1799: 'Special Trade Contractors (Not Elsewhere Classified)',
  2741: 'Miscellaneous Publishing and Printing',
  2791: 'Typesetting, Plate Making and Related Services',
  2842: 'Specialty Cleaning, Polishing, and Sanitation Preparations',
  3000: 'UNITED AIRLINES',
  3001: 'AMERICAN AIRLINES',
  3002: 'PAN AMERICAN',
  3003: 'EUROFLY AIRLINES',
  3004: 'TRANS WORLD AIRLINES',
  3005: 'BRITISH AIRWAYS',
  3006: 'JAPAN AIRLINES',
  3007: 'AIR FRANCE',
  3008: 'LUFTHANSA',
  3009: 'AIR CANADA',
  3010: 'KLM (ROYAL DUTCH AIRLINES)',
  3011: 'AEROFLOT',
  3012: 'QUANTAS',
  3013: 'ITA AIRWAYS (FORMERLY ALITALIA)',
  3014: 'SAUDIA ARABIAN AIRLINES',
  3015: 'SWISS INTERNATIONAL AIRLINES',
  3016: 'SAS',
  3017: 'SOUTH AFRICAN AIRWAYS',
  3018: 'VARIG (BRAZIL)',
  3019: 'EASTERN AIRLINES',
  3020: 'AIR-INDIA',
  3021: 'AIR ALGERIE',
  3022: 'PHILIPPINE AIRLINES',
  3023: 'MEXICANA',
  3024: 'PAKISTAN INTERNATIONAL',
  3025: 'AIR NEW ZEALAND',
  3026: 'EMIRATES AIRLINES',
  3027: 'UTA/INTERAIR',
  3028: 'KM MALTA AIRLINES (FORMERLY AIR MALTA)',
  3029: 'SN BRUSSELS AIRLINES',
  3030: 'AEROLINEAS ARGENTINAS',
  3031: 'OLYMPIC AIRWAYS',
  3032: 'EL AL',
  3033: 'ANSETT AIRLINES',
  3034: 'AUSTRAINLIAN AIRLINES',
  3035: 'TAP (PORTUGAL)',
  3036: 'VASP (BRAZIL)',
  3037: 'EGYPTAIR',
  3038: 'KUWAIT AIRLINES',
  3039: 'AVIANCA',
  3040: 'GULF AIR (BAHRAIN)',
  3041: 'BALKAN-BULGARIAN AIRLINES',
  3042: 'FINNAIR',
  3043: 'AER LINGUS',
  3044: 'AIR LANKA',
  3045: 'NIGERIA AIRWAYS',
  3046: 'CRUZEIRO DO SUL (BRAZIJ)',
  3047: 'THY (TURKEY)',
  3048: 'ROYAL AIR MAROC',
  3049: 'TUNIS AIR',
  3050: 'ICELANDAIR',
  3051: 'AUSTRIAN AIRLINES',
  3052: 'LAN AIRLINES',
  3053: 'AVIACO (SPAIN)',
  3054: 'LADECO (CHILE)',
  3055: 'LAB (BOLIVIA)',
  3056: 'JET AIRWAYS',
  3057: 'EASTWEST AIRLINES (AUSTRALIA)',
  3058: 'DELTA',
  3059: 'DBA AIRLINES',
  3060: 'NORTHWEST',
  3061: 'CONTINENTAL',
  3062: 'HAPAG-LLOYD EXPRESS AIRLINES',
  3063: 'US AIRWAYS',
  3064: 'ADRIA AIRWAYS',
  3065: 'AIRINTER',
  3066: 'SOUTHWEST',
  3067: 'VANGUARD AIRLINES',
  3068: 'AIR ASTANA',
  3069: 'SUN COUNTRY AIRLINES',
  3070: 'FLYDUBAI',
  3071: 'AIR BRITISH COLUMBIA',
  3072: 'CEBU PACIFIC AIRLINES',
  3073: 'Airlines',
  3074: 'Airlines',
  3075: 'SINGAPORE AIRLINES',
  3076: 'AEROMEXICO',
  3077: 'THAI AIRWAYS',
  3078: 'CHINA AIRLINES',
  3079: 'JETSTAR AIRWAYS',
  3080: 'SWOOP INC',
  3081: 'XIAMEN AIRLINES',
  3082: 'KOREAN AIRLINES',
  3083: 'AIR AFRIGUE',
  3084: 'EVA AIRLINES',
  3085: 'MIDWEST EXPRESS AIRLINES, INC.',
  3086: 'CARNIVAL AIRLINES',
  3087: 'METRO AIRLINES',
  3088: 'CROATIA AIRLINES',
  3089: 'TRANSAERO',
  3090: 'UNI AIRWAYS CORPORATION',
  3091: 'Airlines',
  3092: 'Airlines',
  3093: 'Airlines',
  3094: 'ZAMBIA AIRWAYS',
  3095: 'Airlines',
  3096: 'AIR ZIMBABWE',
  3097: 'SPANAIR',
  3098: 'ASIANA AIRLINES',
  3099: 'CATHAY PACIFIC',
  3100: 'MALAYSIAN AIRLINE SYSTEM',
  3101: 'Airlines',
  3102: 'IBERIA',
  3103: 'GARUDA (INDONESIA)',
  3104: 'Airlines',
  3105: 'Airlines',
  3106: 'BRAATHENS S.A.F.E. (NORWAY)',
  3107: 'Airlines',
  3108: 'Airlines',
  3109: 'Airlines',
  3110: 'WINGS AIRWAYS',
  3111: 'BRITISH MIDLAND',
  3112: 'WINDWARD ISLAND',
  3113: 'Airlines',
  3114: 'Airlines',
  3115: 'TOWER AIR',
  3116: 'Airlines',
  3117: 'VIASA',
  3118: 'VALLEY AIRLINES',
  3119: 'Airlines',
  3120: 'Airlines',
  3121: 'Airlines',
  3122: 'Airlines',
  3123: 'Airlines',
  3124: 'Airlines',
  3125: 'TAN',
  3126: 'TALAIR',
  3127: 'TACA INTERNATIONAL',
  3128: 'Airlines',
  3129: 'SURINAM AIRWAYS',
  3130: 'SUN WORLD INTERNATIONAL',
  3131: 'VLM AIRLINES',
  3132: 'FRONTIER AIRLINES',
  3133: 'SUNBELT AIRLINES',
  3134: 'Airlines',
  3135: 'SUDAN AIRWAYS',
  3136: 'QATAR AIRWAYS',
  3137: 'SINGLETON',
  3138: 'SIMMONS AIRLINES',
  3139: 'Airlines',
  3140: 'Airlines',
  3141: 'Airlines',
  3142: 'Airlines',
  3143: 'SCENIC AIRLINES',
  3144: 'VIRGIN ATLANTIC',
  3145: 'SAN JUAN AIRLINES',
  3146: 'LUXAIR',
  3147: 'Airlines',
  3148: 'AIR LITTORAL SA',
  3149: 'Airlines',
  3150: 'Airlines',
  3151: 'AIR ZAIRE',
  3152: 'Airlines',
  3153: 'Airlines',
  3154: 'PRINCEVILLE',
  3155: 'Airlines',
  3156: 'GO FLY LTD',
  3157: 'Airlines',
  3158: 'Airlines',
  3159: 'PBA',
  3160: 'Airlines',
  3161: 'ALL NIPPON AIRWAYS',
  3162: 'Airlines',
  3163: 'Airlines',
  3164: 'NORONTAIR',
  3165: 'NEW YORK HELICOPTER',
  3166: 'Airlines',
  3167: 'AEROCONTINENTE',
  3168: 'HAINAN AIRLINES',
  3169: 'RIYADH AIR',
  3170: 'NOUNT COOK',
  3171: 'CANADIAN AIRLINES INTERNATIONAL',
  3172: 'NATIONAIR',
  3173: 'Airlines',
  3174: 'JETBLUE AIRWAYS',
  3175: 'MIDDLE EAST AIR',
  3176: 'METROFLIGHT AIRLINES',
  3177: 'AIRTRAN AIRWAYS',
  3178: 'MESA AIR',
  3179: 'Airlines',
  3180: 'WESTJET AIRLINES',
  3181: 'MALEV',
  3182: 'LOT (POLAND)',
  3183: 'OMAN AVIATION SERVICES',
  3184: 'LIAT',
  3185: 'LAV (VENEZUELA)',
  3186: 'LAP (PARAGUAY)',
  3187: 'LACSA (COSTA RICA)',
  3188: 'VIRGIN EXPRESS',
  3189: 'Airlines',
  3190: 'JUGOSLAV AIR',
  3191: 'ISLAND AIRLINES',
  3192: 'IRAN AIR',
  3193: 'INDIAN AIRLINES',
  3194: 'Airlines',
  3195: 'Airlines',
  3196: 'HAWAIIAN AIR',
  3197: 'HAVASU AIRLINES',
  3198: 'Airlines',
  3199: 'Airlines',
  3200: 'FUYANA AIRWAYS',
  3201: 'Airlines',
  3202: 'Airlines',
  3203: 'GOLDEN PACIFIC AIR',
  3204: 'FREEDOM AIR',
  3205: 'Airlines',
  3206: 'CHINA EASTERN AIRLINES',
  3207: 'Airlines',
  3208: 'Airlines',
  3209: 'Airlines',
  3210: 'Airlines',
  3211: 'NORWEGIAN AIR SHUTTLE',
  3212: 'DOMINICANA',
  3213: 'BRAATHENS REGIONAL AIRLINES',
  3214: 'Airlines',
  3215: 'DAN AIR SERVICES',
  3216: 'CUMBERLAND AIRLINES',
  3217: 'CSA',
  3218: 'CROWN AIR',
  3219: 'COPA',
  3220: 'COMPANIA FAUCETT',
  3221: 'TRANSPORTES AEROS MILITARES ECCUATORANOS',
  3222: 'COMMAND AIRWAYS',
  3223: 'COMAIR',
  3224: 'Airlines',
  3225: 'Airlines',
  3226: 'SKYWAYS AIR',
  3227: 'Airlines',
  3228: 'CAYMAN AIRWAYS',
  3229: 'SAETA SOCIAEDAD ECUATORIANOS DE TRANSPORTES AEREOS',
  3230: 'Airlines',
  3231: 'SAHSA - SERVICIO AEREO DE HONDURAS',
  3232: 'Airlines',
  3233: 'CAPITOL AIR',
  3234: 'CARIBBEAN AIRLINES',
  3235: 'BROCKWAY AIR',
  3236: 'AIR ARABIA AIRLINE',
  3237: 'Airlines',
  3238: 'BEMIDJI AIRLINES',
  3239: 'BAR HARBOR AIRLINES',
  3240: 'BAHAMASAIR',
  3241: 'AVIATECA (GUATEMALA)',
  3242: 'AVENSA',
  3243: 'AUSTRIAN AIR SERVICE',
  3244: 'Airlines',
  3245: 'EASYJET AIRLINES',
  3246: 'RYANAIR',
  3247: 'GOL AIRLINES',
  3248: 'TAM AIRLINES',
  3249: 'Airlines',
  3250: 'Airlines',
  3251: 'ALOHA AIRLINES',
  3252: 'ALM',
  3253: 'AMERICA WEST',
  3254: 'US AIR SHUTTLE',
  3255: 'Airlines',
  3256: 'ALASKA AIRLINES',
  3257: 'Airlines',
  3258: 'Airlines',
  3259: 'AMERICAN TRANS AIR',
  3260: 'SPIRIT AIRLINES',
  3261: 'AIR CHINA',
  3262: 'RENO AIR, INC.',
  3263: 'AERO SERVICO CARABOBO',
  3264: 'Airlines',
  3265: 'Airlines',
  3266: 'AIR SEYCHELLES',
  3267: 'AIR PANAMA',
  3268: 'Airlines',
  3269: 'Airlines',
  3270: 'Airlines',
  3271: 'Airlines',
  3272: 'Airlines',
  3273: 'Airlines',
  3274: 'Airlines',
  3275: 'Airlines',
  3276: 'Airlines',
  3277: 'Airlines',
  3278: 'Airlines',
  3279: 'Airlines',
  3280: 'AIR JAMAICA',
  3281: 'Airlines',
  3282: 'AIR DJIBOUTI',
  3283: 'Airlines',
  3284: 'AERO VIRGIN ISLANDS',
  3285: 'AERO PERU',
  3286: 'AEROLINEAS NICARAGUENSIS',
  3287: 'AERO COACH AVAIATION',
  3288: 'Airlines',
  3289: 'Airlines',
  3290: 'Airlines',
  3291: 'ARIANA AFGHAN',
  3292: 'CYPRUS AIRWAYS',
  3293: 'ECUATORIANA',
  3294: 'ETHIOPIAN AIRLINES',
  3295: 'KENYA AIRLINES',
  3296: 'AIR BERLIN',
  3297: 'TAROM ROMANIAN AIR TRANSPORT',
  3298: 'AIR MAURITIUS',
  3299: 'WIDEROE’S FLYVESELSKAP',
  3300: 'AZUL AIR',
  3301: 'WIZZ AIR',
  3302: 'FLYBE LTD',
  3303: 'TIGERAIR',
  3304: 'AIR BALTIC',
  3305: 'AIR TRANSAT',
  3308: 'CHINA SOUTHERN AIRLINES',
  3351: 'AFFILIATED AUTO RENTAL',
  3352: 'AMERICAN INTL RENT-A-CAR',
  3353: 'BROOKS RENT-A-CAR',
  3354: 'ACTION AUTO RENTAL',
  3355: 'SIXT CAR RENTAL',
  3356: 'Car Rental',
  3357: 'HERTZ RENT-A-CAR',
  3358: 'Car Rental',
  3359: 'PAYLESS CAR RENTAL',
  3360: 'SNAPPY CAR RENTAL',
  3361: 'AIRWAYS RENT-A-CAR',
  3362: 'ALTRA AUTO RENTAL',
  3363: 'Car Rental',
  3364: 'AGENCY RENT-A-CAR',
  3365: 'Car Rental',
  3366: 'BUDGET RENT-A-CAR',
  3367: 'Car Rental',
  3368: 'HOLIDAY RENT-A-WRECK',
  3369: 'Car Rental',
  3370: 'RENT-A-WRECK',
  3371: 'Car Rental',
  3372: 'Car Rental',
  3373: 'Car Rental',
  3374: 'ACCENT RENT-A-CAR',
  3375: 'Car Rental',
  3376: 'AJAX RENT-A-CAR',
  3377: 'Car Rental',
  3378: 'Car Rental',
  3379: 'Car Rental',
  3380: 'TRIANGLE RENT-A-CAR',
  3381: 'EUROP CAR',
  3382: 'Car Rental',
  3383: 'Car Rental',
  3384: 'Car Rental',
  3385: 'TROPICAL RENT-A-CAR',
  3386: 'SHOWCASE RENTAL CARS',
  3387: 'ALAMO RENT-A-CAR',
  3388: 'MERCHANTS RENT-A-CAR',
  3389: 'AVIS RENT-A-CAR',
  3390: 'DOLLAR RENT-A-CAR',
  3391: 'EUROPE BY CAR',
  3392: 'Car Rental',
  3393: 'NATIONAL CAR RENTAL',
  3394: 'KEMWELL GROUP RENT-A-CAR',
  3395: 'THRIFTY CAR RENTAL',
  3396: 'TILDEN TENT-A-CAR',
  3397: 'Car Rental',
  3398: 'ECONO-CAR RENT-A-CAR',
  3399: 'Car Rental',
  3400: 'AUTO HOST COST CAR RENTALS',
  3401: 'Car Rental',
  3402: 'Car Rental',
  3403: 'Car Rental',
  3404: 'Car Rental',
  3405: 'ENTERPRISE RENT-A-CAR',
  3406: 'Car Rental',
  3407: 'Car Rental',
  3408: 'Car Rental',
  3409: 'GENERAL RENT-A-CAR',
  3410: 'Car Rental',
  3411: 'Car Rental',
  3412: 'A-1 RENT-A-CAR',
  3413: 'Car Rental',
  3414: 'GODFREY NATL RENT-A-CAR',
  3415: 'Car Rental',
  3416: 'Car Rental',
  3417: 'Car Rental',
  3418: 'Car Rental',
  3419: 'ALPHA RENT-A-CAR',
  3420: 'ANSA INTL RENT-A-CAR',
  3421: 'ALLSTATE RENT-A-CAR',
  3422: 'Car Rental',
  3423: 'AVCAR RENT-A-CAR',
  3424: 'Car Rental',
  3425: 'AUTOMATE RENT-A-CAR',
  3426: 'Car Rental',
  3427: 'AVON RENT-A-CAR',
  3428: 'CAREY RENT-A-CAR',
  3429: 'INSURANCE RENT-A-CAR',
  3430: 'MAJOR RENT-A-CAR',
  3431: 'REPLACEMENT RENT-A-CAR',
  3432: 'RESERVE RENT-A-CAR',
  3433: 'UGLY DUCKLING RENT-A-CAR',
  3434: 'USA RENT-A-CAR',
  3435: 'VALUE RENT-A-CAR',
  3436: 'AUTOHANSA RENT-A-CAR',
  3437: 'CITE RENT-A-CAR',
  3438: 'INTERENT RENT-A-CAR',
  3439: 'MILLEVILLE RENT-A-CAR',
  3440: 'VIA ROUTE RENT-A-CAR',
  3441: 'ADVANTAGE RENT-A-CAR',
  3501: 'HOLIDAY INNS, HOLIDAY INN EXPRESS',
  3502: 'BEST WESTERN HOTELS',
  3503: 'SHERATON HOTELS',
  3504: 'HILTON HOTELS',
  3505: 'FORTE HOTELS',
  3506: 'GOLDEN TULIP HOTELS',
  3507: 'FRIENDSHIP INNS',
  3508: 'QUALITY INNS, QUALITY SUITES',
  3509: 'MARRIOTT HOTELS',
  3510: 'DAYS INN, DAYSTOP',
  3511: 'ARABELLA HOTELS',
  3512: 'INTER-CONTINENTAL HOTELS',
  3513: 'WESTIN HOTELS',
  3514: 'AMERISUITES',
  3515: 'RODEWAY INNS',
  3516: 'LA QUINTA INN AND SUITES',
  3517: 'AMERICANA HOTELS',
  3518: 'SOL HOTELS',
  3519: 'PULLMAN INTERNATIONAL HOTELS',
  3520: 'MERIDIEN HOTELS',
  3521: 'CREST HOTELS (see FORTE HOTELS)',
  3522: 'TOKYO HOTEL',
  3523: 'PENINSULA HOTEL',
  3524: 'WELCOMGROUP HOTELS',
  3525: 'DUNFEY HOTELS',
  3526: 'PRINCE HOTELS',
  3527: 'DOWNTOWNER-PASSPORT HOTEL',
  3528: 'RED LION HOTELS, RED LION INNS',
  3529: 'CP HOTELS',
  3530: 'RENAISSANCE HOTELS, STOUFFER HOTELS',
  3531: 'KAUAI COCONUT BEACH RESORT',
  3532: 'ROYAL KONA RESORT',
  3533: 'HOTEL IBIS',
  3534: 'SOUTHERN PACIFIC HOTELS',
  3535: 'HILTON INTERNATIONALS',
  3536: 'AMFAC HOTELS',
  3537: 'ANA HOTEL',
  3538: 'CONCORDE HOTELS',
  3539: 'SUMMERFIELD SUITES HOTELS',
  3540: 'IBEROTEL HOTELS',
  3541: 'HOTEL OKURA',
  3542: 'ROYAL HOTELS',
  3543: 'FOUR SEASONS HOTELS',
  3544: 'CIGA HOTELS',
  3545: 'SHANGRI-LA INTERNATIONAL',
  3546: 'HOTEL SIERRA',
  3547: 'Hotels/Motels/Inns/Resorts',
  3548: 'HOTELES MELIA',
  3549: 'AUBERGE DES GOVERNEURS',
  3550: 'REGAL 8 INNS',
  3551: 'MIRAGE HOTEL AND CASINO',
  3552: 'COAST HOTELS',
  3553: 'PARK INNS INTERNATIONAL',
  3554: 'PINEHURST RESORT',
  3555: 'TREASURE ISLAND HOTEL AND CASINO',
  3556: 'BARTON CREEK RESORT',
  3557: 'MANHATTAN EAST SUITE HOTELS',
  3558: 'JOLLY HOTELS',
  3559: 'CANDLEWOOD SUITES',
  3560: 'ALADDIN RESORT AND CASINO',
  3561: 'GOLDEN NUGGET',
  3562: 'COMFORT INNS',
  3563: 'JOURNEY’S END MOTELS',
  3564: 'SAM’S TOWN HOTEL AND CASINO',
  3565: 'RELAX INNS',
  3566: 'GARDEN PLACE HOTEL',
  3567: 'SOHO GRAND HOTEL',
  3568: 'LADBROKE HOTELS',
  3569: 'TRIBECA GRAND HOTEL',
  3570: 'FORUM HOTELS',
  3571: 'GRAND WAILEA RESORT',
  3572: 'MIYAKO HOTELS',
  3573: 'SANDMAN HOTELS',
  3574: 'VENTURE INNS',
  3575: 'VAGABOND HOTELS',
  3576: 'LA QUINTA RESORT',
  3577: 'MANDARIN ORIENTAL HOTEL',
  3578: 'FRANKENMUTH BAVARIAN',
  3579: 'HOTEL MERCURE',
  3580: 'HOTEL DEL CORONADO',
  3581: 'DELTA HOTEL',
  3582: 'CALIFORNIA HOTEL AND CASINO',
  3583: 'RADISSON BLU',
  3584: 'PRINCESS HOTELS INTERNATIONAL',
  3585: 'HUNGAR HOTELS',
  3586: 'SOKOS HOTELS',
  3587: 'DORAL HOTELS',
  3588: 'HELMSLEY HOTELS',
  3589: 'DORAL GOLF RESORT',
  3590: 'FAIRMONT HOTELS',
  3591: 'SONESTA HOTELS',
  3592: 'OMNI HOTELS',
  3593: 'CUNARD HOTELS',
  3594: 'ARIZONA BILTMORE',
  3595: 'HOSPITALITY INTERNATIONAL',
  3596: 'WYNN LAS VEGAS',
  3597: 'RIVERSIDE RESORT HOTEL AND CASINO',
  3598: 'REGENT INTERNATIONAL HOTELS',
  3599: 'PANNONIA HOTELS',
  3600: 'SADDLEBROOK RESORT TAMPA',
  3601: 'TRADEWINDS RESORTS',
  3602: 'HUDSON HOTEL',
  3603: 'NOAH\'S HOTELS',
  3604: 'HILTON GARDEN INN',
  3605: 'Hotels/Motels/Inns/Resorts',
  3606: 'Hotels/Motels/Inns/Resorts',
  3607: 'FONTAINEBLEAU RESORTS',
  3608: 'GAYLORD OPRYLAND',
  3609: 'GAYLORD PALMS',
  3610: 'Hotels/Motels/Inns/Resorts',
  3611: 'Hotels/Motels/Inns/Resorts',
  3612: 'MOEVENPICK HOTELS',
  3613: 'MICROTEL INNS & SUITES',
  3614: 'AMERICINN',
  3615: 'TRAVELODGE',
  3616: 'Hotels/Motels/Inns/Resorts',
  3617: 'AMERICA’S BEST VALUE INN',
  3618: 'GREAT WOLF',
  3619: 'ALOFT',
  3620: 'BINION’S HORSESHOE CLUB',
  3621: 'EXTENDED STAY',
  3622: 'MERLIN HOTELS',
  3623: 'DORINT HOTELS',
  3624: 'LADY LUCK HOTEL AND CASINO',
  3625: 'HOTLE UNIVERSALE',
  3626: 'PRINCE HOTELS',
  3627: 'EXTENDED STAY AMERICA',
  3628: 'EXCALIBUR HOTEL AND CASINO',
  3629: 'DAN HOTELS',
  3630: 'TOKYU HOTELS',
  3631: 'SLEEP INN',
  3632: 'THE PHOENICIAN',
  3633: 'RANK HOTELS',
  3634: 'SWISSOTEL',
  3635: 'RESO HOTELS',
  3636: 'SAROVA HOTELS',
  3637: 'RAMADA INNS, RAMADA LIMITED',
  3638: 'HO JO INN, HOWARD JOHNSON',
  3639: 'MOUNT CHARLOTTE THISTLE',
  3640: 'HYATT HOTELS',
  3641: 'SOFITEL HOTELS',
  3642: 'NOVOTEL HOTELS',
  3643: 'STEIGENBERGER HOTELS',
  3644: 'ECONO LODGES',
  3645: 'QUEENS MOAT HOUSES',
  3646: 'SWALLOW HOTELS',
  3647: 'HUSA HOTELS',
  3648: 'DE VERE HOTELS',
  3649: 'RADISSON HOTELS',
  3650: 'RED ROOK INNS',
  3651: 'IMPERIAL LONDON HOTEL',
  3652: 'EMBASSY HOTELS',
  3653: 'PENTA HOTELS',
  3654: 'LOEWS HOTELS',
  3655: 'SCANDIC HOTELS',
  3656: 'SARA HOTELS',
  3657: 'OBEROI HOTELS',
  3658: 'NEW OTANI HOTELS',
  3659: 'TAJ HOTELS INTERNATIONAL',
  3660: 'KNIGHTS INNS',
  3661: 'METROPOLE HOTELS',
  3662: 'CIRCUS CIRCUS HOTEL AND CASINO',
  3663: 'HOTELES EL PRESIDENTS',
  3664: 'FLAG INN',
  3665: 'HAMPTON INNS',
  3666: 'STAKIS HOTELS',
  3667: 'LUXOR HOTEL AND CASINO',
  3668: 'MARITIM HOTELS',
  3669: 'ELDORADO HOTEL AND CASINO',
  3670: 'ARCARD HOTELS',
  3671: 'ARCTIA HOTELS',
  3672: 'CAMPANIEL HOTELS',
  3673: 'IBUSZ HOTELS',
  3674: 'RANTASIPI HOTELS',
  3675: 'INTERHOTEL CEDOK',
  3676: 'MONTE CARLO HOTEL AND CASINO',
  3677: 'CLIMAT DE FRANCE HOTELS',
  3678: 'CUMULUS HOTELS',
  3679: 'SILVER LEGACY HOTEL AND CASINO',
  3680: 'HOTEIS OTHAN',
  3681: 'ADAMS MARK HOTELS',
  3682: 'SAHARA HOTEL AND CASINO',
  3683: 'BRADBURY SUITES',
  3684: 'BUDGET HOST INNS',
  3685: 'BUDGETEL HOTELS',
  3686: 'SUISSE CHALETS',
  3687: 'CLARION HOTELS',
  3688: 'COMPRI HOTELS',
  3689: 'CONSORT HOTELS',
  3690: 'COURTYARD BY MARRIOTT',
  3691: 'DILLION INNS',
  3692: 'DOUBLETREE HOTELS',
  3693: 'DRURY INNS',
  3694: 'ECONOMY INNS OF AMERICA',
  3695: 'EMBASSY SUITES',
  3696: 'EXEL INNS',
  3697: 'FARFIELD HOTELS',
  3698: 'HARLEY HOTELS',
  3699: 'MIDWAY MOTOR LODGE',
  3700: 'MOTEL 6',
  3701: 'GUEST QUARTERS (formally PICKETT SUITE HOTELS)',
  3702: 'THE REGISTRY HOTELS',
  3703: 'RESIDENCE INNS',
  3704: 'ROYCE HOTELS',
  3705: 'SANDMAN INNS',
  3706: 'SHILO INNS',
  3707: 'SHONEY\'S INNS',
  3708: 'VIRGIN RIVER HOTEL AND CASINO',
  3709: 'SUPER 8 MOTELS',
  3710: 'THE RITZ CARLTON HOTELS',
  3711: 'FLAG INNS (AUSTRALIA)',
  3712: 'BUFFALO BILL’S HOTEL AND CASINO',
  3713: 'QUALITY PACIFIC HOTEL',
  3714: 'FOUR SEASONS HOTEL (AUSTRALIA)',
  3715: 'FARIFIELD INN',
  3716: 'CARLTON HOTELS',
  3717: 'CITY LODGE HOTELS',
  3718: 'KAROS HOTELS',
  3719: 'PROTEA HOTELS',
  3720: 'SOUTHERN SUN HOTELS',
  3721: 'HILTON CONRAD',
  3722: 'WYNDHAM HOTEL AND RESORTS',
  3723: 'RICA HOTELS',
  3724: 'INER NOR HOTELS',
  3725: 'SEA PINES RESORT',
  3726: 'RIO SUITES',
  3727: 'BROADMOOR HOTEL',
  3728: 'BALLY’S HOTEL AND CASINO',
  3729: 'JOHN ASCUAGA’S NUGGET',
  3730: 'MGM GRAND HOTEL',
  3731: 'HARRAH’S HOTELS AND CASINOS',
  3732: 'OPRYLAND HOTEL',
  3733: 'BOCA RATON RESORT',
  3734: 'HARVEY/BRISTOL HOTELS',
  3735: 'MASTERS ECONOMY INNS',
  3736: 'COLORADO BELLE/EDGEWATER RESORT',
  3737: 'RIVIERA HOTEL AND CASINO',
  3738: 'TROPICANA RESORT & CASINO',
  3739: 'WOODSIDE HOTELS & RESORTS',
  3740: 'TOWNEPLACE SUITES',
  3741: 'MILLENIUM BROADWAY HOTEL',
  3742: 'CLUB MED',
  3743: 'BILTMORE HOTEL & SUITES',
  3744: 'CAREFREE RESORTS',
  3745: 'ST. REGIS HOTEL',
  3746: 'THE ELIOT HOTEL',
  3747: 'CLUBCORP/CLUB RESORTS',
  3748: 'WELLESLEY INNS',
  3749: 'THE BEVERLY HILLS HOTEL',
  3750: 'CROWNE PLAZA HOTELS',
  3751: 'HOMEWOOD SUITES',
  3752: 'PEABODY HOTELS',
  3753: 'GREENBRIAH RESORTS',
  3754: 'AMELIA ISLAND PLANTATION',
  3755: 'THE HOMESTEAD',
  3756: 'SOUTH SEAS RESORTS',
  3757: 'CANYON RANCH',
  3758: 'KAHALA MANDARIN ORIENTAL HOTEL',
  3759: 'THE ORCHID AT MAUNA LANI',
  3760: 'HALEKULANI HOTEL/WAIKIKI PARC',
  3761: 'PRIMADONNA HOTEL AND CASINO',
  3762: 'WHISKEY PETE’S HOTEL AND CASINO',
  3763: 'CHATEAU ELAN WINERY AND RESORT',
  3764: 'BEAU RIVAGE HOTEL AND CASINO',
  3765: 'BELLAGIO',
  3766: 'FREMONT HOTEL AND CASINO',
  3767: 'MAIN STREET STATION HOTEL AND CASINO',
  3768: 'SILVER STAR HOTEL AND CASINO',
  3769: 'STRATOSPHERE HOTEL AND CASINO',
  3770: 'SPRINGHILL SUITES',
  3771: 'CAESAR’S HOTEL AND CASINO',
  3772: 'NEMACOLIN WOODLANDS',
  3773: 'THE VENETIAN RESORT HOTEL CASINO',
  3774: 'NEW YORK-NEW YORK HOTEL AND CASINO',
  3775: 'SANDS RESORT',
  3776: 'NEVELE GRAND RESORT AND COUNTRY CLUB',
  3777: 'MANDALAY BAY RESORT',
  3778: 'FOUR POINTS HOTELS',
  3779: 'W HOTELS',
  3780: 'DISNEY RESORTS',
  3781: 'PATRICIA GRAND RESORT HOTELS',
  3782: 'ROSEN HOTELS AND RESORTS',
  3783: 'TOWN AND COUNTRY RESORT & CONVENTION CENTER',
  3784: 'FIRST HOSPITALITY HOTELS',
  3785: 'OUTRIGGER HOTELS AND RESORTS',
  3786: 'OHANA HOTELS OF HAWAII',
  3787: 'CARIBE ROYALE RESORTS',
  3788: 'ALA MOANA HOTEL',
  3789: 'SMUGGLER’S NOTCH RESORT',
  3790: 'RAFFLES HOTELS',
  3791: 'STAYBRIDGE SUITES',
  3792: 'CLARIDGE CASINO HOTEL',
  3793: 'FLAMINGO HOTELS',
  3794: 'GRAND CASINO HOTELS',
  3795: 'PARIS LAS VEGAS HOTEL',
  3796: 'PEPPERMILL HOTEL CASINO',
  3797: 'ATLANTIC CITY HILTON RESORTS',
  3798: 'EMBASSY VACATION RESORT',
  3799: 'HALE KOA HOTEL',
  3800: 'HOMESTEAD SUITES',
  3801: 'WILDERNESS HOTEL AND RESORT',
  3802: 'THE PALACE HOTEL',
  3807: 'ELEMENT',
  3808: 'LXR',
  3811: 'PREMIER INN',
  3812: 'HYATT PLACE',
  3813: 'HOTEL INDIGO',
  3814: 'THE ROOSEVELT HOTEL NY',
  3815: 'NICKELODEON FAMILY SUITES BY HOLIDAY INN',
  3816: 'Home2Suites',
  3818: 'MAINSTAY SUITES',
  3819: 'OXFORD SUITES',
  3820: 'JUMEIRAH ESSEX HOUSE',
  3821: 'CARIBE ROYALE',
  3822: 'CROSSLAND',
  3823: 'GRAND SIERRA RESORT',
  3824: 'ARIA',
  3825: 'VDARA',
  3826: 'AUTOGRAPH',
  3827: 'GALT HOUSE',
  3828: 'COSMOPOLITAN OF LAS VEGAS',
  3829: 'COUNTRY INN BY RADISSON',
  3830: 'PARK PLAZA HOTEL',
  3831: 'WALDORF',
  3832: 'CURIO HOTELS',
  3833: 'CANOPY',
  3834: 'BAYMONT INN & SUITES',
  3835: '* MASTERS ECONOMY INNS',
  3836: 'HAWTHORN BY WYNDHAM',
  3837: 'HOSHINO RESORTS',
  3838: 'KIMPTON HOTELS',
  3839: 'KYORITSU HOTELS',
  3840: 'RIO HOTELS',
  3841: 'TRIBUTE PORTFOLIO',
  3842: 'MARRIOT EXECUTIVE APARTMENTS',
  3843: 'MOXY',
  3844: 'AC HOTELS',
  3845: 'BULGARI',
  3846: 'THE LUXURY COLLECTION',
  3847: 'JW MARRIOT',
  3848: 'EDITION',
  3849: 'MINACIA',
  3850: 'BREEZBAY GROUP',
  3851: 'CANDEO HOTELS',
  3852: 'CORE GLOBAL MANAGEMENT HOTELS AND RESORTS',
  3853: 'GRANBELL HOTELS AND RESORTS',
  3854: 'JHAT',
  3855: 'C\'EST LA VIE RESORT IZUMIGO',
  3856: 'BANYAN TREE HOTELS & RESORTS',
  3857: 'HOTEL SUNROUTE',
  3858: 'SOTETSU FRESA-INN',
  3859: 'LA VISTA',
  3860: 'JR-EAST HOTEL METS',
  3861: 'AB HOTEL',
  3862: 'CHISUN HOTELS',
  3863: 'SUPER HOTEL',
  3864: 'ITOEN HOTEL',
  3865: 'QUINTESSA HOTEL',
  3866: 'SMILE HOTEL',
  3867: 'HOTEL ALPHA-1',
  3868: 'RELO VACATIONS',
  3869: 'YUTORELO',
  3870: 'KEIO PRESSO INN',
  3871: 'VILLA-FONTAINE',
  3872: 'MEITETSU INN',
  3873: 'TOKYU HARVEST CLUB',
  3874: 'HOTEL LIVEMAX',
  3875: 'FUFU JAPAN',
  3876: 'HMI HOTEL GROUP',
  3877: 'ORIX HOTELS & RESORTS',
  3878: 'WASHINGTON HOTEL',
  3879: 'SANCO INN',
  3880: 'HOTEL UNIZO',
  3881: 'HOTEL METROPOLITAN',
  3882: 'CENTURION HOTELS',
  3883: 'NEST HOTEL',
  4011: 'Railroads',
  4111: 'Local/Suburban Commuter Passenger Transportation - Railroads, Feries, Local Water Transportation.',
  4112: 'Passenger Railways',
  4119: 'Ambulance Services',
  4121: 'Taxicabs and Limousines',
  4131: 'Bus Lines, Including Charters, Tour Buses',
  4214: 'Motor Freight Carriers and Trucking - Local and Long Distance, Moving and Storage Companies, and Local Delivery',
  4215: 'Courier Services - Air and Ground, and Freight Forwarders',
  4225: 'Public Warehousing and Storage - Farm Products, Refrigerated Goods, Household Goods, and Storage',
  4411: 'Cruise and Steamship Lines',
  4457: 'Boat Rentals and Leasing',
  4468: 'Marinas, Marine Service, and Supplies',
  4511: 'Airlines and Air Carriers (Not Elsewhere Classified)',
  4582: 'Airports, Flying Fields, and Airport Terminals',
  4722: 'Travel Agencies and Tour Operations',
  4723: 'Package Tour Operators (for use in Germany only)',
  4784: 'Tolls and Bridge Fees',
  4789: 'Transportation Services (Not Elsewhere Classified)',
  4812: 'Telecommunications Equipment including telephone sales',
  4814: 'Telecommunication Services, including Local and Long-Distance Calls, Credit Card Calls, Calls Through Use of Magnetic-',
  4815: 'VisaPhone',
  4816: 'Computer Network/Information Services',
  4821: 'Telegraph services',
  4829: 'Money Orders - Wire Transfer',
  4899: 'Cable, Satellite and Other Pay Television/Radio/Streaming Services',
  4900: 'Utilities - Electric, Gas, Water, and Sanitary',
  5013: 'Motor vehicle supplies and new parts',
  5021: 'Office and Commercial Furniture',
  5039: 'Construction Materials (Not Elsewhere Classified)',
  5044: 'Photographic, Photocopy, Microfilm Equipment and Supplies',
  5045: 'Computers and Computer Peripheral Equipment and Software',
  5046: 'Commercial Equipment (Not Elsewhere Classified)',
  5047: 'Medical, Dental, Ophthalmic and Hospital Equipment and Supplies',
  5051: 'Metal Service Centers and Offices',
  5065: 'Electrical Parts and Equipment',
  5072: 'Hardware, Equipment and Supplies',
  5074: 'Plumbing and Heating Equipment and Supplies',
  5085: 'Industrial Supplies (Not Elsewhere Classified)',
  5094: 'Precious Stones and Metals, Watches and Jewelry',
  5099: 'Durable Goods (Not Elsewhere Classified)',
  5111: 'Stationery, Office Supplies, Printing, and Writing Paper',
  5122: 'Drugs, Drug Proprietors, and Druggist\'s Sundries',
  5131: 'Piece Goods, Notions, and Other Dry Goods',
  5137: 'Men’s, Women’s, and Children’s Uniforms and Commercial Clothing',
  5139: 'Commercial Footwear',
  5169: 'Chemicals and Allied Products (Not Elsewhere Classified)',
  5172: 'Petroleum and Petroleum Products',
  5192: 'Books, Periodicals, and Newspapers',
  5193: 'Florists\' Supplies, Nursery Stock and Flowers',
  5198: 'Paints, Varnishes, and Supplies',
  5199: 'Nondurable Goods (Not Elsewhere Classified)',
  5200: 'Home Supply Warehouse Stores',
  5211: 'Lumber and Building Materials Stores',
  5231: 'Glass, Paint, and Wallpaper Stores',
  5251: 'Hardware Stores',
  5261: 'Nurseries and Lawn and Garden Supply Stores',
  5262: 'Marketplaces',
  5271: 'Mobile Home Dealers',
  5300: 'Wholesale Clubs',
  5309: 'Duty Free Stores',
  5310: 'Discount Stores',
  5311: 'Department Stores',
  5331: 'Variety Stores',
  5399: 'Miscellaneous General Merchandise',
  5411: 'Grocery Stores, Supermarkets',
  5422: 'Meat Provisioners - Freezer and Locker',
  5441: 'Candy, Nut, and Confectionery Stores',
  5451: 'Dairy Products Stores',
  5462: 'Bakeries',
  5499: 'Miscellaneous Food Stores - Convenience Stores and Specialty Markets',
  5511: 'Car and Truck Dealers (New and Used) Sales, Service, Repairs, Parts, and Leasing',
  5521: 'Car and Truck Dealers (Used Only) Sales, Service, Repairs, Parts, and Leasing',
  5531: 'Automobile Supply Stores',
  5532: 'Automotive Tire Stores',
  5533: 'Automotive Parts, Accessories Stores',
  5541: 'Service Stations (with or without ancillary services)',
  5542: 'Automated Fuel Dispensers',
  5551: 'Boat Dealers',
  5552: 'Electric Vehicle Charging',
  5561: 'Camper, Recreational and Utility Trailer Dealers',
  5571: 'Motorcycle Shops and Dealers',
  5592: 'Motor Homes Dealers',
  5598: 'Snowmobile Dealers',
  5599: 'Miscellaneous Automotive, Aircraft, and Farm Equipment Dealers (Not Elsewhere Classified)',
  5611: 'Men\'s and Boy\'s Clothing and Accessories Stores',
  5621: 'Women\'s Ready-to-Wear Stores',
  5631: 'Women\'s Accessory and Specialty Shops',
  5641: 'Children\'s and Infant\'s Wear Stores',
  5651: 'Family Clothing Stores',
  5655: 'Sports Apparel, Riding Apparel Stores',
  5661: 'Shoe Stores',
  5681: 'Furriers and Fur Shops',
  5691: 'Men\'s and Women\'s Clothing Stores',
  5697: 'Tailors, Seamstresses, Mending, and Alterations',
  5698: 'Wig and Toupee Stores',
  5699: 'Miscellaneous Apparel and Accessory Shops',
  5712: 'Furniture, Home Furnishings, and Equipment Stores, Except Appliances',
  5713: 'Floor Covering Stores',
  5714: 'Drapery, Window Covering, and Upholstery Stores',
  5718: 'Fireplace, Fireplace Screens, and Accessories Stores',
  5719: 'Miscellaneous Home Furnishing Specialty Stores',
  5722: 'Household Appliance Stores',
  5723: 'Guns and Ammunition Shops',
  5732: 'Electronics Stores',
  5733: 'Music Stores - Musical Instruments, Pianos, and Sheet Music',
  5734: 'Computer Software Stores',
  5735: 'Record Stores',
  5811: 'Caterers',
  5812: 'Eating places and Restaurants',
  5813: 'Drinking Places (Alcoholic Beverages) - Bars, Taverns, Nightclubs, Cocktail Lounges, and Discotheques',
  5814: 'Fast Food Restaurants',
  5815: 'Digital Goods Media - Books, Movies, Digital artwork/images, Music',
  5816: 'Digital Goods - Games',
  5817: 'Digital Goods - Applications (Excludes Games)',
  5818: 'Digital Goods - Large Digital Goods Merchant',
  5832: 'Antique Shops - Sales, Repairs, and Restoration Services',
  5912: 'Drug Stores and Pharmacies',
  5921: 'Package Stores - Beer, Wine, and Liquor',
  5931: 'Used Merchandise and Secondhand Stores',
  5932: 'Antique Shops - Sales, Repairs, and Restoration Services',
  5933: 'Pawn Shops and Salvage Yards',
  5935: 'Wrecking and Salvage Yards',
  5937: 'Antique Reproductions',
  5940: 'Bicycle Shops - Sales and Service',
  5941: 'Sporting Goods Stores',
  5942: 'Book Stores',
  5943: 'Stationery Stores, Office and School Supply Stores',
  5944: 'Jewelry Stores, Watches, Clocks, and Silverware Stores',
  5945: 'Hobby, Toy, and Game Shops',
  5946: 'Camera and Photographic Supply Stores',
  5947: 'Card Shops, Gift, Novelty, and Souvenir Shops',
  5948: 'Luggage and Leather Goods Stores',
  5949: 'Sewing, Needlework, Fabric and Piece Goods Stores',
  5950: 'Glassware/Crystal Stores',
  5960: 'Direct Marketing - Insurance Services',
  5961: 'Mail Order Houses Including Catalog Order Stores, Book/Record Clubs (No longer permitted for U.S. original presentments)',
  5962: 'Direct Marketing - Travel Related Arrangements Services',
  5963: 'Door-to-Door Sales',
  5964: 'Direct Marketing - Catalog Merchant',
  5965: 'Direct Marketing - Catalog and Catalog and Retail Merchant',
  5966: 'Direct Marketing - Outbound Telemarketing Merchant',
  5967: 'Direct Marketing - Inbound Teleservices Merchant',
  5968: 'Direct Marketing - Continuity/Subscription Merchant',
  5969: 'Direct Marketing - Other Direct Marketers (Not Elsewhere Classified)',
  5970: 'Artist\'s Supply and Craft Shops',
  5971: 'Art Dealers and Galleries',
  5972: 'Stamp and Coin Stores - Philatelic and Numismatic Supplies',
  5973: 'Religious Goods Stores',
  5975: 'Hearing Aids - Sales, Service, and Supply Stores',
  5976: 'Orthopedic Goods - Prosthetic Devices',
  5977: 'Cosmetic Stores',
  5978: 'Typewriter Stores - Sales, Rentals, and Service',
  5983: 'Fuel Dealers - Fuel Oil, Wood, Coal, and Liquefied Petroleum',
  5992: 'Florists',
  5993: 'Cigar Stores and Stands',
  5994: 'News Dealers and Newsstands',
  5995: 'Pet Shops, Pet Foods, and Supplies Stores',
  5996: 'Swimming Pools - Sales, Service, and Supplies',
  5997: 'Electric Razor Stores - Sales and Service',
  5998: 'Tent and Awning Shops',
  5999: 'Miscellaneous and Specialty Retail Stores',
  6010: 'Financial Institutions - Manual Cash Disbursements',
  6011: 'Financial Institutions - Automated Cash Disbursements',
  6012: 'Financial Institutions - Merchandise, Services, and Debt Repayment',
  6051: 'Non-Financial Institutions - Foreign Currency, Liquid and Cryptocurrency Assets (for example: Cryptocurrency), Money',
  6211: 'Security Brokers/Dealers',
  6300: 'Insurance Sales, Underwriting, and Premiums',
  6381: 'Insurance Premiums, (no longer valid for first presentment work)',
  6399: 'Insurance Not Elsewhere Classified (no longer valid forfirst presentment work)',
  6513: 'Real Estate Agents and Managers - Rentals',
  6540: 'Non-Financial Institutions - Stored Value Card Purchase/Load',
  7011: 'Lodging - Hotels, Motels, Resorts, Central Reservation Services (Not Elsewhere Classified)',
  7012: 'Timeshares',
  7032: 'Sporting and Recreational Camps',
  7033: 'Trailer Parks and Camp Grounds',
  7210: 'Laundry, Cleaning, and Garment Services',
  7211: 'Laundries - Family and Commercial',
  7216: 'Dry Cleaners',
  7217: 'Carpet and Upholstery Cleaning',
  7221: 'Photographic Studios',
  7230: 'Barber and Beauty Shops',
  7251: 'Shop Repair Shops and Shoe Shine Parlors, and Hat Cleaning Shops',
  7261: 'Funeral Services and Crematories',
  7273: 'Dating and Escort Services',
  7276: 'Tax Preparation Services',
  7277: 'Counseling Services - Debt, Marriage, and Personal',
  7278: 'Buying and Shopping Services and Clubs',
  7296: 'Clothing Rental - Costumes, Formal Wear, Uniforms',
  7297: 'Massage Parlors',
  7298: 'Health and Beauty Shops',
  7299: 'Miscellaneous Personal Services (Not Elsewhere Classified)',
  7311: 'Advertising Services',
  7321: 'Consumer Credit Reporting Agencies',
  7322: 'Collection Agencies',
  7332: 'Blueprinting and Photocopying Services',
  7333: 'Commercial Photography, Art, and Graphics',
  7338: 'Quick Copy, Reproduction, and Blueprinting Services',
  7339: 'Stenographic and Secretarial Support Services',
  7342: 'Exterminating and Disinfecting Services',
  7349: 'Cleaning, Maintenance, and Janitorial Services',
  7361: 'Employment Agencies, Temporary Help Services',
  7372: 'Computer Programming, Data Processing, and Integrated Systems Design Services',
  7375: 'Information Retrieval Services',
  7379: 'Computer Maintenance, Repair and Services (Not Elsewhere Classified)',
  7392: 'Management, Consulting, and Public Relations Services',
  7393: 'Detective Agencies, Protective Services, and Security Services, including Armored Cars, and Guard Dogs',
  7394: 'Equipment Rental and Leasing Services, Tool Rental, Furniture Rental, and Appliance Rental',
  7395: 'Photofinishing Laboratories, Photo Developing',
  7399: 'Business Services (Not Elsewhere Classified)',
  7511: 'Truck Stop',
  7512: 'Car Rental Companies Not Listed Below',
  7513: 'Truck and Utility Trailer Rentals',
  7519: 'Motor Home and Recreational Vehicle Rentals',
  7523: 'Parking Lots, Parking Meters and Garages',
  7531: 'Automotive Body Repair Shops',
  7534: 'Tire Re-treading and Repair Shops',
  7535: 'Paint Shops - Automotive',
  7538: 'Automotive Service Shops (Non-Dealer)',
  7542: 'Car Washes',
  7549: 'Towing Services',
  7622: 'Electronics Repair Shops',
  7623: 'Air Conditioning and Refrigeration Repair Shops',
  7629: 'Electrical And Small Appliance Repair Shops',
  7631: 'Watch, Clock, and Jewelry Repair',
  7641: 'Furniture, Furniture Repair, and Furniture Refinishing',
  7692: 'Welding Services',
  7699: 'Repair Shops and Related Services -Miscellaneous',
  7800: 'Government-Owned Lotteries (US Region only)',
  7801: 'Government Licensed On-Line Casinos (On-Line Gambling) (US Region only)',
  7802: 'Government-Licensed Horse/Dog Racing (US Region only)',
  7829: 'Motion Pictures and Video Tape Production and Distribution',
  7832: 'Motion Picture Theaters',
  7841: 'DVD/Video Tape Rental Stores',
  7911: 'Dance Halls, Studios and Schools',
  7922: 'Ticket Agencies and Theatrical Producers (Except Motion Pictures)',
  7929: 'Bands, Orchestras, and Miscellaneous Entertainers (Not Elsewhere Classified)',
  7932: 'Billiard and Pool Establishments',
  7933: 'Bowling Alleys',
  7941: 'Commercial Sports, Professional Sports Clubs, Athletic Fields, and Sports Promoters',
  7991: 'Tourist Attractions and Exhibits',
  7992: 'Golf Courses - Public',
  7993: 'Video Amusement Game Supplies',
  7994: 'Video Game Arcades/Establishments',
  7995: 'Betting, including Lottery Tickets, Casino Gaming Chips, Off-Track Betting, Wagers at Race Tracks and games of chance to',
  7996: 'Amusement Parks, Circuses, Carnivals, and Fortune Tellers',
  7997: 'Membership Clubs (Sports, Recreation, Athletic), Country Clubs, and Private Golf Courses',
  7998: 'Aquariums, Seaquariums, Dolphinariums, and Zoos',
  7999: 'Recreation Services (Not Elsewhere Classified)',
  8011: 'Doctors and Physicians (Not Elsewhere Classified)',
  8021: 'Dentists and Orthodontists',
  8031: 'Osteopaths',
  8041: 'Chiropractors',
  8042: 'Optometrists and Ophthalmologists',
  8043: 'Opticians, Opticians Goods and Eyeglasses',
  8044: 'Opticians, Optical Goods, and Eyeglasses (no longer valid for first presentments)',
  8049: 'Podiatrists and Chiropodists',
  8050: 'Nursing, Home Healthcare and Personal Care Facilities',
  8062: 'Hospitals',
  8071: 'Medical and Dental Laboratories',
  8099: 'Medical Services and Health Practitioners (Not Elsewhere Classified)',
  8111: 'Legal Services and Attorneys',
  8211: 'Elementary and Secondary Schools',
  8220: 'Colleges, Universities, Professional Schools, and Junior Colleges',
  8241: 'Correspondence Schools',
  8244: 'Business and Secretarial Schools',
  8249: 'Vocational Schools and Trade Schools',
  8299: 'Schools and Educational Services (Not Elsewhere Classified)',
  8351: 'Child Care Services',
  8398: 'Charitable and Social Service Organizations',
  8641: 'Civic, Fraternal, and Social Associations',
  8651: 'Political Organizations',
  8661: 'Religious Organizations',
  8675: 'Automobile Associations',
  8699: 'Membership Organizations (Not Elsewhere Classified)',
  8734: 'Testing Laboratories (Non-Medical Testing)',
  8911: 'Architectural, Engineering, and Surveying Services',
  8931: 'Accounting, Auditing, and Bookkeeping Services',
  8999: 'Professional Services (Not Elsewhere Classified)',
  9211: 'Court Costs, including Alimony and Child Support',
  9222: 'Fines',
  9223: 'Bail and Bond Payments',
  9311: 'Tax Payments',
  9399: 'Government Services (Not Elsewhere Classified)',
  9402: 'Postal Services - Government Only',
  9405: 'U.S. Federal Government Agencies or Departments',
  9406: 'Government-Owned Lotteries (Non-U.S. region)',
  9700: 'Automated Referral Service (For Visa Only)',
  9701: 'Visa Credential Service (For Visa Only)',
  9702: 'Emergency Services (GCAS) (Visa use only)',
  9950: 'Intra - Company Purchases (For Visa Only)',
} as const;

export type MerchantCategoryCode = keyof typeof merchantCategoryCode;

export const merchantCategoryCodeChoices = [
  { id: '0742', name: '0742 - Veterinary Services' },
  { id: '0763', name: '0763 - Agricultural Co-operatives' },
  { id: '0780', name: '0780 - Horticultural Services, Landscaping Services' },
  { id: '1520', name: '1520 - General Contractors - Residential and Commercial' },
  { id: '1711', name: '1711 - Air Conditioning Contractors - Sales and Installation, Heating Contractors - Sales, Service, Installation' },
  { id: '1731', name: '1731 - Electrical Contractors' },
  { id: '1740', name: '1740 - Insulation - Contractors, Masonry, Stonework Contractors, Plastering Contractors, Stonework and Masonry Contractors, Tile Settings Contractors' },
  { id: '1750', name: '1750 - Carpentry Contractors' },
  { id: '1761', name: '1761 - Roofing - Contractors, Sheet Metal Work - Contractors, Siding - Contractors' },
  { id: '1771', name: '1771 - Contractors - Concrete Work' },
  { id: '1799', name: '1799 - Special Trade Contractors (Not Elsewhere Classified)' },
  { id: '2741', name: '2741 - Miscellaneous Publishing and Printing' },
  { id: '2791', name: '2791 - Typesetting, Plate Making and Related Services' },
  { id: '2842', name: '2842 - Specialty Cleaning, Polishing, and Sanitation Preparations' },
  { id: '3000', name: '3000 - UNITED AIRLINES' },
  { id: '3001', name: '3001 - AMERICAN AIRLINES' },
  { id: '3002', name: '3002 - PAN AMERICAN' },
  { id: '3003', name: '3003 - EUROFLY AIRLINES' },
  { id: '3004', name: '3004 - TRANS WORLD AIRLINES' },
  { id: '3005', name: '3005 - BRITISH AIRWAYS' },
  { id: '3006', name: '3006 - JAPAN AIRLINES' },
  { id: '3007', name: '3007 - AIR FRANCE' },
  { id: '3008', name: '3008 - LUFTHANSA' },
  { id: '3009', name: '3009 - AIR CANADA' },
  { id: '3010', name: '3010 - KLM (ROYAL DUTCH AIRLINES)' },
  { id: '3011', name: '3011 - AEROFLOT' },
  { id: '3012', name: '3012 - QUANTAS' },
  { id: '3013', name: '3013 - ITA AIRWAYS (FORMERLY ALITALIA)' },
  { id: '3014', name: '3014 - SAUDIA ARABIAN AIRLINES' },
  { id: '3015', name: '3015 - SWISS INTERNATIONAL AIRLINES' },
  { id: '3016', name: '3016 - SAS' },
  { id: '3017', name: '3017 - SOUTH AFRICAN AIRWAYS' },
  { id: '3018', name: '3018 - VARIG (BRAZIL)' },
  { id: '3019', name: '3019 - EASTERN AIRLINES' },
  { id: '3020', name: '3020 - AIR-INDIA' },
  { id: '3021', name: '3021 - AIR ALGERIE' },
  { id: '3022', name: '3022 - PHILIPPINE AIRLINES' },
  { id: '3023', name: '3023 - MEXICANA' },
  { id: '3024', name: '3024 - PAKISTAN INTERNATIONAL' },
  { id: '3025', name: '3025 - AIR NEW ZEALAND' },
  { id: '3026', name: '3026 - EMIRATES AIRLINES' },
  { id: '3027', name: '3027 - UTA/INTERAIR' },
  { id: '3028', name: '3028 - KM MALTA AIRLINES (FORMERLY AIR MALTA)' },
  { id: '3029', name: '3029 - SN BRUSSELS AIRLINES' },
  { id: '3030', name: '3030 - AEROLINEAS ARGENTINAS' },
  { id: '3031', name: '3031 - OLYMPIC AIRWAYS' },
  { id: '3032', name: '3032 - EL AL' },
  { id: '3033', name: '3033 - ANSETT AIRLINES' },
  { id: '3034', name: '3034 - AUSTRAINLIAN AIRLINES' },
  { id: '3035', name: '3035 - TAP (PORTUGAL)' },
  { id: '3036', name: '3036 - VASP (BRAZIL)' },
  { id: '3037', name: '3037 - EGYPTAIR' },
  { id: '3038', name: '3038 - KUWAIT AIRLINES' },
  { id: '3039', name: '3039 - AVIANCA' },
  { id: '3040', name: '3040 - GULF AIR (BAHRAIN)' },
  { id: '3041', name: '3041 - BALKAN-BULGARIAN AIRLINES' },
  { id: '3042', name: '3042 - FINNAIR' },
  { id: '3043', name: '3043 - AER LINGUS' },
  { id: '3044', name: '3044 - AIR LANKA' },
  { id: '3045', name: '3045 - NIGERIA AIRWAYS' },
  { id: '3046', name: '3046 - CRUZEIRO DO SUL (BRAZIJ)' },
  { id: '3047', name: '3047 - THY (TURKEY)' },
  { id: '3048', name: '3048 - ROYAL AIR MAROC' },
  { id: '3049', name: '3049 - TUNIS AIR' },
  { id: '3050', name: '3050 - ICELANDAIR' },
  { id: '3051', name: '3051 - AUSTRIAN AIRLINES' },
  { id: '3052', name: '3052 - LAN AIRLINES' },
  { id: '3053', name: '3053 - AVIACO (SPAIN)' },
  { id: '3054', name: '3054 - LADECO (CHILE)' },
  { id: '3055', name: '3055 - LAB (BOLIVIA)' },
  { id: '3056', name: '3056 - JET AIRWAYS' },
  { id: '3057', name: '3057 - EASTWEST AIRLINES (AUSTRALIA)' },
  { id: '3058', name: '3058 - DELTA' },
  { id: '3059', name: '3059 - DBA AIRLINES' },
  { id: '3060', name: '3060 - NORTHWEST' },
  { id: '3061', name: '3061 - CONTINENTAL' },
  { id: '3062', name: '3062 - HAPAG-LLOYD EXPRESS AIRLINES' },
  { id: '3063', name: '3063 - US AIRWAYS' },
  { id: '3064', name: '3064 - ADRIA AIRWAYS' },
  { id: '3065', name: '3065 - AIRINTER' },
  { id: '3066', name: '3066 - SOUTHWEST' },
  { id: '3067', name: '3067 - VANGUARD AIRLINES' },
  { id: '3068', name: '3068 - AIR ASTANA' },
  { id: '3069', name: '3069 - SUN COUNTRY AIRLINES' },
  { id: '3070', name: '3070 - FLYDUBAI' },
  { id: '3071', name: '3071 - AIR BRITISH COLUMBIA' },
  { id: '3072', name: '3072 - CEBU PACIFIC AIRLINES' },
  { id: '3073', name: '3073 - Airlines' },
  { id: '3074', name: '3074 - Airlines' },
  { id: '3075', name: '3075 - SINGAPORE AIRLINES' },
  { id: '3076', name: '3076 - AEROMEXICO' },
  { id: '3077', name: '3077 - THAI AIRWAYS' },
  { id: '3078', name: '3078 - CHINA AIRLINES' },
  { id: '3079', name: '3079 - JETSTAR AIRWAYS' },
  { id: '3080', name: '3080 - SWOOP INC' },
  { id: '3081', name: '3081 - XIAMEN AIRLINES' },
  { id: '3082', name: '3082 - KOREAN AIRLINES' },
  { id: '3083', name: '3083 - AIR AFRIGUE' },
  { id: '3084', name: '3084 - EVA AIRLINES' },
  { id: '3085', name: '3085 - MIDWEST EXPRESS AIRLINES, INC.' },
  { id: '3086', name: '3086 - CARNIVAL AIRLINES' },
  { id: '3087', name: '3087 - METRO AIRLINES' },
  { id: '3088', name: '3088 - CROATIA AIRLINES' },
  { id: '3089', name: '3089 - TRANSAERO' },
  { id: '3090', name: '3090 - UNI AIRWAYS CORPORATION' },
  { id: '3091', name: '3091 - Airlines' },
  { id: '3092', name: '3092 - Airlines' },
  { id: '3093', name: '3093 - Airlines' },
  { id: '3094', name: '3094 - ZAMBIA AIRWAYS' },
  { id: '3095', name: '3095 - Airlines' },
  { id: '3096', name: '3096 - AIR ZIMBABWE' },
  { id: '3097', name: '3097 - SPANAIR' },
  { id: '3098', name: '3098 - ASIANA AIRLINES' },
  { id: '3099', name: '3099 - CATHAY PACIFIC' },
  { id: '3100', name: '3100 - MALAYSIAN AIRLINE SYSTEM' },
  { id: '3101', name: '3101 - Airlines' },
  { id: '3102', name: '3102 - IBERIA' },
  { id: '3103', name: '3103 - GARUDA (INDONESIA)' },
  { id: '3104', name: '3104 - Airlines' },
  { id: '3105', name: '3105 - Airlines' },
  { id: '3106', name: '3106 - BRAATHENS S.A.F.E. (NORWAY)' },
  { id: '3107', name: '3107 - Airlines' },
  { id: '3108', name: '3108 - Airlines' },
  { id: '3109', name: '3109 - Airlines' },
  { id: '3110', name: '3110 - WINGS AIRWAYS' },
  { id: '3111', name: '3111 - BRITISH MIDLAND' },
  { id: '3112', name: '3112 - WINDWARD ISLAND' },
  { id: '3113', name: '3113 - Airlines' },
  { id: '3114', name: '3114 - Airlines' },
  { id: '3115', name: '3115 - TOWER AIR' },
  { id: '3116', name: '3116 - Airlines' },
  { id: '3117', name: '3117 - VIASA' },
  { id: '3118', name: '3118 - VALLEY AIRLINES' },
  { id: '3119', name: '3119 - Airlines' },
  { id: '3120', name: '3120 - Airlines' },
  { id: '3121', name: '3121 - Airlines' },
  { id: '3122', name: '3122 - Airlines' },
  { id: '3123', name: '3123 - Airlines' },
  { id: '3124', name: '3124 - Airlines' },
  { id: '3125', name: '3125 - TAN' },
  { id: '3126', name: '3126 - TALAIR' },
  { id: '3127', name: '3127 - TACA INTERNATIONAL' },
  { id: '3128', name: '3128 - Airlines' },
  { id: '3129', name: '3129 - SURINAM AIRWAYS' },
  { id: '3130', name: '3130 - SUN WORLD INTERNATIONAL' },
  { id: '3131', name: '3131 - VLM AIRLINES' },
  { id: '3132', name: '3132 - FRONTIER AIRLINES' },
  { id: '3133', name: '3133 - SUNBELT AIRLINES' },
  { id: '3134', name: '3134 - Airlines' },
  { id: '3135', name: '3135 - SUDAN AIRWAYS' },
  { id: '3136', name: '3136 - QATAR AIRWAYS' },
  { id: '3137', name: '3137 - SINGLETON' },
  { id: '3138', name: '3138 - SIMMONS AIRLINES' },
  { id: '3139', name: '3139 - Airlines' },
  { id: '3140', name: '3140 - Airlines' },
  { id: '3141', name: '3141 - Airlines' },
  { id: '3142', name: '3142 - Airlines' },
  { id: '3143', name: '3143 - SCENIC AIRLINES' },
  { id: '3144', name: '3144 - VIRGIN ATLANTIC' },
  { id: '3145', name: '3145 - SAN JUAN AIRLINES' },
  { id: '3146', name: '3146 - LUXAIR' },
  { id: '3147', name: '3147 - Airlines' },
  { id: '3148', name: '3148 - AIR LITTORAL SA' },
  { id: '3149', name: '3149 - Airlines' },
  { id: '3150', name: '3150 - Airlines' },
  { id: '3151', name: '3151 - AIR ZAIRE' },
  { id: '3152', name: '3152 - Airlines' },
  { id: '3153', name: '3153 - Airlines' },
  { id: '3154', name: '3154 - PRINCEVILLE' },
  { id: '3155', name: '3155 - Airlines' },
  { id: '3156', name: '3156 - GO FLY LTD' },
  { id: '3157', name: '3157 - Airlines' },
  { id: '3158', name: '3158 - Airlines' },
  { id: '3159', name: '3159 - PBA' },
  { id: '3160', name: '3160 - Airlines' },
  { id: '3161', name: '3161 - ALL NIPPON AIRWAYS' },
  { id: '3162', name: '3162 - Airlines' },
  { id: '3163', name: '3163 - Airlines' },
  { id: '3164', name: '3164 - NORONTAIR' },
  { id: '3165', name: '3165 - NEW YORK HELICOPTER' },
  { id: '3166', name: '3166 - Airlines' },
  { id: '3167', name: '3167 - AEROCONTINENTE' },
  { id: '3168', name: '3168 - HAINAN AIRLINES' },
  { id: '3169', name: '3169 - RIYADH AIR' },
  { id: '3170', name: '3170 - NOUNT COOK' },
  { id: '3171', name: '3171 - CANADIAN AIRLINES INTERNATIONAL' },
  { id: '3172', name: '3172 - NATIONAIR' },
  { id: '3173', name: '3173 - Airlines' },
  { id: '3174', name: '3174 - JETBLUE AIRWAYS' },
  { id: '3175', name: '3175 - MIDDLE EAST AIR' },
  { id: '3176', name: '3176 - METROFLIGHT AIRLINES' },
  { id: '3177', name: '3177 - AIRTRAN AIRWAYS' },
  { id: '3178', name: '3178 - MESA AIR' },
  { id: '3179', name: '3179 - Airlines' },
  { id: '3180', name: '3180 - WESTJET AIRLINES' },
  { id: '3181', name: '3181 - MALEV' },
  { id: '3182', name: '3182 - LOT (POLAND)' },
  { id: '3183', name: '3183 - OMAN AVIATION SERVICES' },
  { id: '3184', name: '3184 - LIAT' },
  { id: '3185', name: '3185 - LAV (VENEZUELA)' },
  { id: '3186', name: '3186 - LAP (PARAGUAY)' },
  { id: '3187', name: '3187 - LACSA (COSTA RICA)' },
  { id: '3188', name: '3188 - VIRGIN EXPRESS' },
  { id: '3189', name: '3189 - Airlines' },
  { id: '3190', name: '3190 - JUGOSLAV AIR' },
  { id: '3191', name: '3191 - ISLAND AIRLINES' },
  { id: '3192', name: '3192 - IRAN AIR' },
  { id: '3193', name: '3193 - INDIAN AIRLINES' },
  { id: '3194', name: '3194 - Airlines' },
  { id: '3195', name: '3195 - Airlines' },
  { id: '3196', name: '3196 - HAWAIIAN AIR' },
  { id: '3197', name: '3197 - HAVASU AIRLINES' },
  { id: '3198', name: '3198 - Airlines' },
  { id: '3199', name: '3199 - Airlines' },
  { id: '3200', name: '3200 - FUYANA AIRWAYS' },
  { id: '3201', name: '3201 - Airlines' },
  { id: '3202', name: '3202 - Airlines' },
  { id: '3203', name: '3203 - GOLDEN PACIFIC AIR' },
  { id: '3204', name: '3204 - FREEDOM AIR' },
  { id: '3205', name: '3205 - Airlines' },
  { id: '3206', name: '3206 - CHINA EASTERN AIRLINES' },
  { id: '3207', name: '3207 - Airlines' },
  { id: '3208', name: '3208 - Airlines' },
  { id: '3209', name: '3209 - Airlines' },
  { id: '3210', name: '3210 - Airlines' },
  { id: '3211', name: '3211 - NORWEGIAN AIR SHUTTLE' },
  { id: '3212', name: '3212 - DOMINICANA' },
  { id: '3213', name: '3213 - BRAATHENS REGIONAL AIRLINES' },
  { id: '3214', name: '3214 - Airlines' },
  { id: '3215', name: '3215 - DAN AIR SERVICES' },
  { id: '3216', name: '3216 - CUMBERLAND AIRLINES' },
  { id: '3217', name: '3217 - CSA' },
  { id: '3218', name: '3218 - CROWN AIR' },
  { id: '3219', name: '3219 - COPA' },
  { id: '3220', name: '3220 - COMPANIA FAUCETT' },
  { id: '3221', name: '3221 - TRANSPORTES AEROS MILITARES ECCUATORANOS' },
  { id: '3222', name: '3222 - COMMAND AIRWAYS' },
  { id: '3223', name: '3223 - COMAIR' },
  { id: '3224', name: '3224 - Airlines' },
  { id: '3225', name: '3225 - Airlines' },
  { id: '3226', name: '3226 - SKYWAYS AIR' },
  { id: '3227', name: '3227 - Airlines' },
  { id: '3228', name: '3228 - CAYMAN AIRWAYS' },
  { id: '3229', name: '3229 - SAETA SOCIAEDAD ECUATORIANOS DE TRANSPORTES AEREOS' },
  { id: '3230', name: '3230 - Airlines' },
  { id: '3231', name: '3231 - SAHSA - SERVICIO AEREO DE HONDURAS' },
  { id: '3232', name: '3232 - Airlines' },
  { id: '3233', name: '3233 - CAPITOL AIR' },
  { id: '3234', name: '3234 - CARIBBEAN AIRLINES' },
  { id: '3235', name: '3235 - BROCKWAY AIR' },
  { id: '3236', name: '3236 - AIR ARABIA AIRLINE' },
  { id: '3237', name: '3237 - Airlines' },
  { id: '3238', name: '3238 - BEMIDJI AIRLINES' },
  { id: '3239', name: '3239 - BAR HARBOR AIRLINES' },
  { id: '3240', name: '3240 - BAHAMASAIR' },
  { id: '3241', name: '3241 - AVIATECA (GUATEMALA)' },
  { id: '3242', name: '3242 - AVENSA' },
  { id: '3243', name: '3243 - AUSTRIAN AIR SERVICE' },
  { id: '3244', name: '3244 - Airlines' },
  { id: '3245', name: '3245 - EASYJET AIRLINES' },
  { id: '3246', name: '3246 - RYANAIR' },
  { id: '3247', name: '3247 - GOL AIRLINES' },
  { id: '3248', name: '3248 - TAM AIRLINES' },
  { id: '3249', name: '3249 - Airlines' },
  { id: '3250', name: '3250 - Airlines' },
  { id: '3251', name: '3251 - ALOHA AIRLINES' },
  { id: '3252', name: '3252 - ALM' },
  { id: '3253', name: '3253 - AMERICA WEST' },
  { id: '3254', name: '3254 - US AIR SHUTTLE' },
  { id: '3255', name: '3255 - Airlines' },
  { id: '3256', name: '3256 - ALASKA AIRLINES' },
  { id: '3257', name: '3257 - Airlines' },
  { id: '3258', name: '3258 - Airlines' },
  { id: '3259', name: '3259 - AMERICAN TRANS AIR' },
  { id: '3260', name: '3260 - SPIRIT AIRLINES' },
  { id: '3261', name: '3261 - AIR CHINA' },
  { id: '3262', name: '3262 - RENO AIR, INC.' },
  { id: '3263', name: '3263 - AERO SERVICO CARABOBO' },
  { id: '3264', name: '3264 - Airlines' },
  { id: '3265', name: '3265 - Airlines' },
  { id: '3266', name: '3266 - AIR SEYCHELLES' },
  { id: '3267', name: '3267 - AIR PANAMA' },
  { id: '3268', name: '3268 - Airlines' },
  { id: '3269', name: '3269 - Airlines' },
  { id: '3270', name: '3270 - Airlines' },
  { id: '3271', name: '3271 - Airlines' },
  { id: '3272', name: '3272 - Airlines' },
  { id: '3273', name: '3273 - Airlines' },
  { id: '3274', name: '3274 - Airlines' },
  { id: '3275', name: '3275 - Airlines' },
  { id: '3276', name: '3276 - Airlines' },
  { id: '3277', name: '3277 - Airlines' },
  { id: '3278', name: '3278 - Airlines' },
  { id: '3279', name: '3279 - Airlines' },
  { id: '3280', name: '3280 - AIR JAMAICA' },
  { id: '3281', name: '3281 - Airlines' },
  { id: '3282', name: '3282 - AIR DJIBOUTI' },
  { id: '3283', name: '3283 - Airlines' },
  { id: '3284', name: '3284 - AERO VIRGIN ISLANDS' },
  { id: '3285', name: '3285 - AERO PERU' },
  { id: '3286', name: '3286 - AEROLINEAS NICARAGUENSIS' },
  { id: '3287', name: '3287 - AERO COACH AVAIATION' },
  { id: '3288', name: '3288 - Airlines' },
  { id: '3289', name: '3289 - Airlines' },
  { id: '3290', name: '3290 - Airlines' },
  { id: '3291', name: '3291 - ARIANA AFGHAN' },
  { id: '3292', name: '3292 - CYPRUS AIRWAYS' },
  { id: '3293', name: '3293 - ECUATORIANA' },
  { id: '3294', name: '3294 - ETHIOPIAN AIRLINES' },
  { id: '3295', name: '3295 - KENYA AIRLINES' },
  { id: '3296', name: '3296 - AIR BERLIN' },
  { id: '3297', name: '3297 - TAROM ROMANIAN AIR TRANSPORT' },
  { id: '3298', name: '3298 - AIR MAURITIUS' },
  { id: '3299', name: '3299 - WIDEROE’S FLYVESELSKAP' },
  { id: '3300', name: '3300 - AZUL AIR' },
  { id: '3301', name: '3301 - WIZZ AIR' },
  { id: '3302', name: '3302 - FLYBE LTD' },
  { id: '3303', name: '3303 - TIGERAIR' },
  { id: '3304', name: '3304 - AIR BALTIC' },
  { id: '3305', name: '3305 - AIR TRANSAT' },
  { id: '3308', name: '3308 - CHINA SOUTHERN AIRLINES' },
  { id: '3351', name: '3351 - AFFILIATED AUTO RENTAL' },
  { id: '3352', name: '3352 - AMERICAN INTL RENT-A-CAR' },
  { id: '3353', name: '3353 - BROOKS RENT-A-CAR' },
  { id: '3354', name: '3354 - ACTION AUTO RENTAL' },
  { id: '3355', name: '3355 - SIXT CAR RENTAL' },
  { id: '3356', name: '3356 - Car Rental' },
  { id: '3357', name: '3357 - HERTZ RENT-A-CAR' },
  { id: '3358', name: '3358 - Car Rental' },
  { id: '3359', name: '3359 - PAYLESS CAR RENTAL' },
  { id: '3360', name: '3360 - SNAPPY CAR RENTAL' },
  { id: '3361', name: '3361 - AIRWAYS RENT-A-CAR' },
  { id: '3362', name: '3362 - ALTRA AUTO RENTAL' },
  { id: '3363', name: '3363 - Car Rental' },
  { id: '3364', name: '3364 - AGENCY RENT-A-CAR' },
  { id: '3365', name: '3365 - Car Rental' },
  { id: '3366', name: '3366 - BUDGET RENT-A-CAR' },
  { id: '3367', name: '3367 - Car Rental' },
  { id: '3368', name: '3368 - HOLIDAY RENT-A-WRECK' },
  { id: '3369', name: '3369 - Car Rental' },
  { id: '3370', name: '3370 - RENT-A-WRECK' },
  { id: '3371', name: '3371 - Car Rental' },
  { id: '3372', name: '3372 - Car Rental' },
  { id: '3373', name: '3373 - Car Rental' },
  { id: '3374', name: '3374 - ACCENT RENT-A-CAR' },
  { id: '3375', name: '3375 - Car Rental' },
  { id: '3376', name: '3376 - AJAX RENT-A-CAR' },
  { id: '3377', name: '3377 - Car Rental' },
  { id: '3378', name: '3378 - Car Rental' },
  { id: '3379', name: '3379 - Car Rental' },
  { id: '3380', name: '3380 - TRIANGLE RENT-A-CAR' },
  { id: '3381', name: '3381 - EUROP CAR' },
  { id: '3382', name: '3382 - Car Rental' },
  { id: '3383', name: '3383 - Car Rental' },
  { id: '3384', name: '3384 - Car Rental' },
  { id: '3385', name: '3385 - TROPICAL RENT-A-CAR' },
  { id: '3386', name: '3386 - SHOWCASE RENTAL CARS' },
  { id: '3387', name: '3387 - ALAMO RENT-A-CAR' },
  { id: '3388', name: '3388 - MERCHANTS RENT-A-CAR' },
  { id: '3389', name: '3389 - AVIS RENT-A-CAR' },
  { id: '3390', name: '3390 - DOLLAR RENT-A-CAR' },
  { id: '3391', name: '3391 - EUROPE BY CAR' },
  { id: '3392', name: '3392 - Car Rental' },
  { id: '3393', name: '3393 - NATIONAL CAR RENTAL' },
  { id: '3394', name: '3394 - KEMWELL GROUP RENT-A-CAR' },
  { id: '3395', name: '3395 - THRIFTY CAR RENTAL' },
  { id: '3396', name: '3396 - TILDEN TENT-A-CAR' },
  { id: '3397', name: '3397 - Car Rental' },
  { id: '3398', name: '3398 - ECONO-CAR RENT-A-CAR' },
  { id: '3399', name: '3399 - Car Rental' },
  { id: '3400', name: '3400 - AUTO HOST COST CAR RENTALS' },
  { id: '3401', name: '3401 - Car Rental' },
  { id: '3402', name: '3402 - Car Rental' },
  { id: '3403', name: '3403 - Car Rental' },
  { id: '3404', name: '3404 - Car Rental' },
  { id: '3405', name: '3405 - ENTERPRISE RENT-A-CAR' },
  { id: '3406', name: '3406 - Car Rental' },
  { id: '3407', name: '3407 - Car Rental' },
  { id: '3408', name: '3408 - Car Rental' },
  { id: '3409', name: '3409 - GENERAL RENT-A-CAR' },
  { id: '3410', name: '3410 - Car Rental' },
  { id: '3411', name: '3411 - Car Rental' },
  { id: '3412', name: '3412 - A-1 RENT-A-CAR' },
  { id: '3413', name: '3413 - Car Rental' },
  { id: '3414', name: '3414 - GODFREY NATL RENT-A-CAR' },
  { id: '3415', name: '3415 - Car Rental' },
  { id: '3416', name: '3416 - Car Rental' },
  { id: '3417', name: '3417 - Car Rental' },
  { id: '3418', name: '3418 - Car Rental' },
  { id: '3419', name: '3419 - ALPHA RENT-A-CAR' },
  { id: '3420', name: '3420 - ANSA INTL RENT-A-CAR' },
  { id: '3421', name: '3421 - ALLSTATE RENT-A-CAR' },
  { id: '3422', name: '3422 - Car Rental' },
  { id: '3423', name: '3423 - AVCAR RENT-A-CAR' },
  { id: '3424', name: '3424 - Car Rental' },
  { id: '3425', name: '3425 - AUTOMATE RENT-A-CAR' },
  { id: '3426', name: '3426 - Car Rental' },
  { id: '3427', name: '3427 - AVON RENT-A-CAR' },
  { id: '3428', name: '3428 - CAREY RENT-A-CAR' },
  { id: '3429', name: '3429 - INSURANCE RENT-A-CAR' },
  { id: '3430', name: '3430 - MAJOR RENT-A-CAR' },
  { id: '3431', name: '3431 - REPLACEMENT RENT-A-CAR' },
  { id: '3432', name: '3432 - RESERVE RENT-A-CAR' },
  { id: '3433', name: '3433 - UGLY DUCKLING RENT-A-CAR' },
  { id: '3434', name: '3434 - USA RENT-A-CAR' },
  { id: '3435', name: '3435 - VALUE RENT-A-CAR' },
  { id: '3436', name: '3436 - AUTOHANSA RENT-A-CAR' },
  { id: '3437', name: '3437 - CITE RENT-A-CAR' },
  { id: '3438', name: '3438 - INTERENT RENT-A-CAR' },
  { id: '3439', name: '3439 - MILLEVILLE RENT-A-CAR' },
  { id: '3440', name: '3440 - VIA ROUTE RENT-A-CAR' },
  { id: '3441', name: '3441 - ADVANTAGE RENT-A-CAR' },
  { id: '3501', name: '3501 - HOLIDAY INNS, HOLIDAY INN EXPRESS' },
  { id: '3502', name: '3502 - BEST WESTERN HOTELS' },
  { id: '3503', name: '3503 - SHERATON HOTELS' },
  { id: '3504', name: '3504 - HILTON HOTELS' },
  { id: '3505', name: '3505 - FORTE HOTELS' },
  { id: '3506', name: '3506 - GOLDEN TULIP HOTELS' },
  { id: '3507', name: '3507 - FRIENDSHIP INNS' },
  { id: '3508', name: '3508 - QUALITY INNS, QUALITY SUITES' },
  { id: '3509', name: '3509 - MARRIOTT HOTELS' },
  { id: '3510', name: '3510 - DAYS INN, DAYSTOP' },
  { id: '3511', name: '3511 - ARABELLA HOTELS' },
  { id: '3512', name: '3512 - INTER-CONTINENTAL HOTELS' },
  { id: '3513', name: '3513 - WESTIN HOTELS' },
  { id: '3514', name: '3514 - AMERISUITES' },
  { id: '3515', name: '3515 - RODEWAY INNS' },
  { id: '3516', name: '3516 - LA QUINTA INN AND SUITES' },
  { id: '3517', name: '3517 - AMERICANA HOTELS' },
  { id: '3518', name: '3518 - SOL HOTELS' },
  { id: '3519', name: '3519 - PULLMAN INTERNATIONAL HOTELS' },
  { id: '3520', name: '3520 - MERIDIEN HOTELS' },
  { id: '3521', name: '3521 - CREST HOTELS (see FORTE HOTELS)' },
  { id: '3522', name: '3522 - TOKYO HOTEL' },
  { id: '3523', name: '3523 - PENINSULA HOTEL' },
  { id: '3524', name: '3524 - WELCOMGROUP HOTELS' },
  { id: '3525', name: '3525 - DUNFEY HOTELS' },
  { id: '3526', name: '3526 - PRINCE HOTELS' },
  { id: '3527', name: '3527 - DOWNTOWNER-PASSPORT HOTEL' },
  { id: '3528', name: '3528 - RED LION HOTELS, RED LION INNS' },
  { id: '3529', name: '3529 - CP HOTELS' },
  { id: '3530', name: '3530 - RENAISSANCE HOTELS, STOUFFER HOTELS' },
  { id: '3531', name: '3531 - KAUAI COCONUT BEACH RESORT' },
  { id: '3532', name: '3532 - ROYAL KONA RESORT' },
  { id: '3533', name: '3533 - HOTEL IBIS' },
  { id: '3534', name: '3534 - SOUTHERN PACIFIC HOTELS' },
  { id: '3535', name: '3535 - HILTON INTERNATIONALS' },
  { id: '3536', name: '3536 - AMFAC HOTELS' },
  { id: '3537', name: '3537 - ANA HOTEL' },
  { id: '3538', name: '3538 - CONCORDE HOTELS' },
  { id: '3539', name: '3539 - SUMMERFIELD SUITES HOTELS' },
  { id: '3540', name: '3540 - IBEROTEL HOTELS' },
  { id: '3541', name: '3541 - HOTEL OKURA' },
  { id: '3542', name: '3542 - ROYAL HOTELS' },
  { id: '3543', name: '3543 - FOUR SEASONS HOTELS' },
  { id: '3544', name: '3544 - CIGA HOTELS' },
  { id: '3545', name: '3545 - SHANGRI-LA INTERNATIONAL' },
  { id: '3546', name: '3546 - HOTEL SIERRA' },
  { id: '3547', name: '3547 - Hotels/Motels/Inns/Resorts' },
  { id: '3548', name: '3548 - HOTELES MELIA' },
  { id: '3549', name: '3549 - AUBERGE DES GOVERNEURS' },
  { id: '3550', name: '3550 - REGAL 8 INNS' },
  { id: '3551', name: '3551 - MIRAGE HOTEL AND CASINO' },
  { id: '3552', name: '3552 - COAST HOTELS' },
  { id: '3553', name: '3553 - PARK INNS INTERNATIONAL' },
  { id: '3554', name: '3554 - PINEHURST RESORT' },
  { id: '3555', name: '3555 - TREASURE ISLAND HOTEL AND CASINO' },
  { id: '3556', name: '3556 - BARTON CREEK RESORT' },
  { id: '3557', name: '3557 - MANHATTAN EAST SUITE HOTELS' },
  { id: '3558', name: '3558 - JOLLY HOTELS' },
  { id: '3559', name: '3559 - CANDLEWOOD SUITES' },
  { id: '3560', name: '3560 - ALADDIN RESORT AND CASINO' },
  { id: '3561', name: '3561 - GOLDEN NUGGET' },
  { id: '3562', name: '3562 - COMFORT INNS' },
  { id: '3563', name: '3563 - JOURNEY’S END MOTELS' },
  { id: '3564', name: '3564 - SAM’S TOWN HOTEL AND CASINO' },
  { id: '3565', name: '3565 - RELAX INNS' },
  { id: '3566', name: '3566 - GARDEN PLACE HOTEL' },
  { id: '3567', name: '3567 - SOHO GRAND HOTEL' },
  { id: '3568', name: '3568 - LADBROKE HOTELS' },
  { id: '3569', name: '3569 - TRIBECA GRAND HOTEL' },
  { id: '3570', name: '3570 - FORUM HOTELS' },
  { id: '3571', name: '3571 - GRAND WAILEA RESORT' },
  { id: '3572', name: '3572 - MIYAKO HOTELS' },
  { id: '3573', name: '3573 - SANDMAN HOTELS' },
  { id: '3574', name: '3574 - VENTURE INNS' },
  { id: '3575', name: '3575 - VAGABOND HOTELS' },
  { id: '3576', name: '3576 - LA QUINTA RESORT' },
  { id: '3577', name: '3577 - MANDARIN ORIENTAL HOTEL' },
  { id: '3578', name: '3578 - FRANKENMUTH BAVARIAN' },
  { id: '3579', name: '3579 - HOTEL MERCURE' },
  { id: '3580', name: '3580 - HOTEL DEL CORONADO' },
  { id: '3581', name: '3581 - DELTA HOTEL' },
  { id: '3582', name: '3582 - CALIFORNIA HOTEL AND CASINO' },
  { id: '3583', name: '3583 - RADISSON BLU' },
  { id: '3584', name: '3584 - PRINCESS HOTELS INTERNATIONAL' },
  { id: '3585', name: '3585 - HUNGAR HOTELS' },
  { id: '3586', name: '3586 - SOKOS HOTELS' },
  { id: '3587', name: '3587 - DORAL HOTELS' },
  { id: '3588', name: '3588 - HELMSLEY HOTELS' },
  { id: '3589', name: '3589 - DORAL GOLF RESORT' },
  { id: '3590', name: '3590 - FAIRMONT HOTELS' },
  { id: '3591', name: '3591 - SONESTA HOTELS' },
  { id: '3592', name: '3592 - OMNI HOTELS' },
  { id: '3593', name: '3593 - CUNARD HOTELS' },
  { id: '3594', name: '3594 - ARIZONA BILTMORE' },
  { id: '3595', name: '3595 - HOSPITALITY INTERNATIONAL' },
  { id: '3596', name: '3596 - WYNN LAS VEGAS' },
  { id: '3597', name: '3597 - RIVERSIDE RESORT HOTEL AND CASINO' },
  { id: '3598', name: '3598 - REGENT INTERNATIONAL HOTELS' },
  { id: '3599', name: '3599 - PANNONIA HOTELS' },
  { id: '3600', name: '3600 - SADDLEBROOK RESORT TAMPA' },
  { id: '3601', name: '3601 - TRADEWINDS RESORTS' },
  { id: '3602', name: '3602 - HUDSON HOTEL' },
  { id: '3603', name: '3603 - NOAH\'S HOTELS' },
  { id: '3604', name: '3604 - HILTON GARDEN INN' },
  { id: '3605', name: '3605 - Hotels/Motels/Inns/Resorts' },
  { id: '3606', name: '3606 - Hotels/Motels/Inns/Resorts' },
  { id: '3607', name: '3607 - FONTAINEBLEAU RESORTS' },
  { id: '3608', name: '3608 - GAYLORD OPRYLAND' },
  { id: '3609', name: '3609 - GAYLORD PALMS' },
  { id: '3610', name: '3610 - Hotels/Motels/Inns/Resorts' },
  { id: '3611', name: '3611 - Hotels/Motels/Inns/Resorts' },
  { id: '3612', name: '3612 - MOEVENPICK HOTELS' },
  { id: '3613', name: '3613 - MICROTEL INNS & SUITES' },
  { id: '3614', name: '3614 - AMERICINN' },
  { id: '3615', name: '3615 - TRAVELODGE' },
  { id: '3616', name: '3616 - Hotels/Motels/Inns/Resorts' },
  { id: '3617', name: '3617 - AMERICA’S BEST VALUE INN' },
  { id: '3618', name: '3618 - GREAT WOLF' },
  { id: '3619', name: '3619 - ALOFT' },
  { id: '3620', name: '3620 - BINION’S HORSESHOE CLUB' },
  { id: '3621', name: '3621 - EXTENDED STAY' },
  { id: '3622', name: '3622 - MERLIN HOTELS' },
  { id: '3623', name: '3623 - DORINT HOTELS' },
  { id: '3624', name: '3624 - LADY LUCK HOTEL AND CASINO' },
  { id: '3625', name: '3625 - HOTLE UNIVERSALE' },
  { id: '3626', name: '3626 - PRINCE HOTELS' },
  { id: '3627', name: '3627 - EXTENDED STAY AMERICA' },
  { id: '3628', name: '3628 - EXCALIBUR HOTEL AND CASINO' },
  { id: '3629', name: '3629 - DAN HOTELS' },
  { id: '3630', name: '3630 - TOKYU HOTELS' },
  { id: '3631', name: '3631 - SLEEP INN' },
  { id: '3632', name: '3632 - THE PHOENICIAN' },
  { id: '3633', name: '3633 - RANK HOTELS' },
  { id: '3634', name: '3634 - SWISSOTEL' },
  { id: '3635', name: '3635 - RESO HOTELS' },
  { id: '3636', name: '3636 - SAROVA HOTELS' },
  { id: '3637', name: '3637 - RAMADA INNS, RAMADA LIMITED' },
  { id: '3638', name: '3638 - HO JO INN, HOWARD JOHNSON' },
  { id: '3639', name: '3639 - MOUNT CHARLOTTE THISTLE' },
  { id: '3640', name: '3640 - HYATT HOTELS' },
  { id: '3641', name: '3641 - SOFITEL HOTELS' },
  { id: '3642', name: '3642 - NOVOTEL HOTELS' },
  { id: '3643', name: '3643 - STEIGENBERGER HOTELS' },
  { id: '3644', name: '3644 - ECONO LODGES' },
  { id: '3645', name: '3645 - QUEENS MOAT HOUSES' },
  { id: '3646', name: '3646 - SWALLOW HOTELS' },
  { id: '3647', name: '3647 - HUSA HOTELS' },
  { id: '3648', name: '3648 - DE VERE HOTELS' },
  { id: '3649', name: '3649 - RADISSON HOTELS' },
  { id: '3650', name: '3650 - RED ROOK INNS' },
  { id: '3651', name: '3651 - IMPERIAL LONDON HOTEL' },
  { id: '3652', name: '3652 - EMBASSY HOTELS' },
  { id: '3653', name: '3653 - PENTA HOTELS' },
  { id: '3654', name: '3654 - LOEWS HOTELS' },
  { id: '3655', name: '3655 - SCANDIC HOTELS' },
  { id: '3656', name: '3656 - SARA HOTELS' },
  { id: '3657', name: '3657 - OBEROI HOTELS' },
  { id: '3658', name: '3658 - NEW OTANI HOTELS' },
  { id: '3659', name: '3659 - TAJ HOTELS INTERNATIONAL' },
  { id: '3660', name: '3660 - KNIGHTS INNS' },
  { id: '3661', name: '3661 - METROPOLE HOTELS' },
  { id: '3662', name: '3662 - CIRCUS CIRCUS HOTEL AND CASINO' },
  { id: '3663', name: '3663 - HOTELES EL PRESIDENTS' },
  { id: '3664', name: '3664 - FLAG INN' },
  { id: '3665', name: '3665 - HAMPTON INNS' },
  { id: '3666', name: '3666 - STAKIS HOTELS' },
  { id: '3667', name: '3667 - LUXOR HOTEL AND CASINO' },
  { id: '3668', name: '3668 - MARITIM HOTELS' },
  { id: '3669', name: '3669 - ELDORADO HOTEL AND CASINO' },
  { id: '3670', name: '3670 - ARCARD HOTELS' },
  { id: '3671', name: '3671 - ARCTIA HOTELS' },
  { id: '3672', name: '3672 - CAMPANIEL HOTELS' },
  { id: '3673', name: '3673 - IBUSZ HOTELS' },
  { id: '3674', name: '3674 - RANTASIPI HOTELS' },
  { id: '3675', name: '3675 - INTERHOTEL CEDOK' },
  { id: '3676', name: '3676 - MONTE CARLO HOTEL AND CASINO' },
  { id: '3677', name: '3677 - CLIMAT DE FRANCE HOTELS' },
  { id: '3678', name: '3678 - CUMULUS HOTELS' },
  { id: '3679', name: '3679 - SILVER LEGACY HOTEL AND CASINO' },
  { id: '3680', name: '3680 - HOTEIS OTHAN' },
  { id: '3681', name: '3681 - ADAMS MARK HOTELS' },
  { id: '3682', name: '3682 - SAHARA HOTEL AND CASINO' },
  { id: '3683', name: '3683 - BRADBURY SUITES' },
  { id: '3684', name: '3684 - BUDGET HOST INNS' },
  { id: '3685', name: '3685 - BUDGETEL HOTELS' },
  { id: '3686', name: '3686 - SUISSE CHALETS' },
  { id: '3687', name: '3687 - CLARION HOTELS' },
  { id: '3688', name: '3688 - COMPRI HOTELS' },
  { id: '3689', name: '3689 - CONSORT HOTELS' },
  { id: '3690', name: '3690 - COURTYARD BY MARRIOTT' },
  { id: '3691', name: '3691 - DILLION INNS' },
  { id: '3692', name: '3692 - DOUBLETREE HOTELS' },
  { id: '3693', name: '3693 - DRURY INNS' },
  { id: '3694', name: '3694 - ECONOMY INNS OF AMERICA' },
  { id: '3695', name: '3695 - EMBASSY SUITES' },
  { id: '3696', name: '3696 - EXEL INNS' },
  { id: '3697', name: '3697 - FARFIELD HOTELS' },
  { id: '3698', name: '3698 - HARLEY HOTELS' },
  { id: '3699', name: '3699 - MIDWAY MOTOR LODGE' },
  { id: '3700', name: '3700 - MOTEL 6' },
  { id: '3701', name: '3701 - GUEST QUARTERS (formally PICKETT SUITE HOTELS)' },
  { id: '3702', name: '3702 - THE REGISTRY HOTELS' },
  { id: '3703', name: '3703 - RESIDENCE INNS' },
  { id: '3704', name: '3704 - ROYCE HOTELS' },
  { id: '3705', name: '3705 - SANDMAN INNS' },
  { id: '3706', name: '3706 - SHILO INNS' },
  { id: '3707', name: '3707 - SHONEY\'S INNS' },
  { id: '3708', name: '3708 - VIRGIN RIVER HOTEL AND CASINO' },
  { id: '3709', name: '3709 - SUPER 8 MOTELS' },
  { id: '3710', name: '3710 - THE RITZ CARLTON HOTELS' },
  { id: '3711', name: '3711 - FLAG INNS (AUSTRALIA)' },
  { id: '3712', name: '3712 - BUFFALO BILL’S HOTEL AND CASINO' },
  { id: '3713', name: '3713 - QUALITY PACIFIC HOTEL' },
  { id: '3714', name: '3714 - FOUR SEASONS HOTEL (AUSTRALIA)' },
  { id: '3715', name: '3715 - FARIFIELD INN' },
  { id: '3716', name: '3716 - CARLTON HOTELS' },
  { id: '3717', name: '3717 - CITY LODGE HOTELS' },
  { id: '3718', name: '3718 - KAROS HOTELS' },
  { id: '3719', name: '3719 - PROTEA HOTELS' },
  { id: '3720', name: '3720 - SOUTHERN SUN HOTELS' },
  { id: '3721', name: '3721 - HILTON CONRAD' },
  { id: '3722', name: '3722 - WYNDHAM HOTEL AND RESORTS' },
  { id: '3723', name: '3723 - RICA HOTELS' },
  { id: '3724', name: '3724 - INER NOR HOTELS' },
  { id: '3725', name: '3725 - SEA PINES RESORT' },
  { id: '3726', name: '3726 - RIO SUITES' },
  { id: '3727', name: '3727 - BROADMOOR HOTEL' },
  { id: '3728', name: '3728 - BALLY’S HOTEL AND CASINO' },
  { id: '3729', name: '3729 - JOHN ASCUAGA’S NUGGET' },
  { id: '3730', name: '3730 - MGM GRAND HOTEL' },
  { id: '3731', name: '3731 - HARRAH’S HOTELS AND CASINOS' },
  { id: '3732', name: '3732 - OPRYLAND HOTEL' },
  { id: '3733', name: '3733 - BOCA RATON RESORT' },
  { id: '3734', name: '3734 - HARVEY/BRISTOL HOTELS' },
  { id: '3735', name: '3735 - MASTERS ECONOMY INNS' },
  { id: '3736', name: '3736 - COLORADO BELLE/EDGEWATER RESORT' },
  { id: '3737', name: '3737 - RIVIERA HOTEL AND CASINO' },
  { id: '3738', name: '3738 - TROPICANA RESORT & CASINO' },
  { id: '3739', name: '3739 - WOODSIDE HOTELS & RESORTS' },
  { id: '3740', name: '3740 - TOWNEPLACE SUITES' },
  { id: '3741', name: '3741 - MILLENIUM BROADWAY HOTEL' },
  { id: '3742', name: '3742 - CLUB MED' },
  { id: '3743', name: '3743 - BILTMORE HOTEL & SUITES' },
  { id: '3744', name: '3744 - CAREFREE RESORTS' },
  { id: '3745', name: '3745 - ST. REGIS HOTEL' },
  { id: '3746', name: '3746 - THE ELIOT HOTEL' },
  { id: '3747', name: '3747 - CLUBCORP/CLUB RESORTS' },
  { id: '3748', name: '3748 - WELLESLEY INNS' },
  { id: '3749', name: '3749 - THE BEVERLY HILLS HOTEL' },
  { id: '3750', name: '3750 - CROWNE PLAZA HOTELS' },
  { id: '3751', name: '3751 - HOMEWOOD SUITES' },
  { id: '3752', name: '3752 - PEABODY HOTELS' },
  { id: '3753', name: '3753 - GREENBRIAH RESORTS' },
  { id: '3754', name: '3754 - AMELIA ISLAND PLANTATION' },
  { id: '3755', name: '3755 - THE HOMESTEAD' },
  { id: '3756', name: '3756 - SOUTH SEAS RESORTS' },
  { id: '3757', name: '3757 - CANYON RANCH' },
  { id: '3758', name: '3758 - KAHALA MANDARIN ORIENTAL HOTEL' },
  { id: '3759', name: '3759 - THE ORCHID AT MAUNA LANI' },
  { id: '3760', name: '3760 - HALEKULANI HOTEL/WAIKIKI PARC' },
  { id: '3761', name: '3761 - PRIMADONNA HOTEL AND CASINO' },
  { id: '3762', name: '3762 - WHISKEY PETE’S HOTEL AND CASINO' },
  { id: '3763', name: '3763 - CHATEAU ELAN WINERY AND RESORT' },
  { id: '3764', name: '3764 - BEAU RIVAGE HOTEL AND CASINO' },
  { id: '3765', name: '3765 - BELLAGIO' },
  { id: '3766', name: '3766 - FREMONT HOTEL AND CASINO' },
  { id: '3767', name: '3767 - MAIN STREET STATION HOTEL AND CASINO' },
  { id: '3768', name: '3768 - SILVER STAR HOTEL AND CASINO' },
  { id: '3769', name: '3769 - STRATOSPHERE HOTEL AND CASINO' },
  { id: '3770', name: '3770 - SPRINGHILL SUITES' },
  { id: '3771', name: '3771 - CAESAR’S HOTEL AND CASINO' },
  { id: '3772', name: '3772 - NEMACOLIN WOODLANDS' },
  { id: '3773', name: '3773 - THE VENETIAN RESORT HOTEL CASINO' },
  { id: '3774', name: '3774 - NEW YORK-NEW YORK HOTEL AND CASINO' },
  { id: '3775', name: '3775 - SANDS RESORT' },
  { id: '3776', name: '3776 - NEVELE GRAND RESORT AND COUNTRY CLUB' },
  { id: '3777', name: '3777 - MANDALAY BAY RESORT' },
  { id: '3778', name: '3778 - FOUR POINTS HOTELS' },
  { id: '3779', name: '3779 - W HOTELS' },
  { id: '3780', name: '3780 - DISNEY RESORTS' },
  { id: '3781', name: '3781 - PATRICIA GRAND RESORT HOTELS' },
  { id: '3782', name: '3782 - ROSEN HOTELS AND RESORTS' },
  { id: '3783', name: '3783 - TOWN AND COUNTRY RESORT & CONVENTION CENTER' },
  { id: '3784', name: '3784 - FIRST HOSPITALITY HOTELS' },
  { id: '3785', name: '3785 - OUTRIGGER HOTELS AND RESORTS' },
  { id: '3786', name: '3786 - OHANA HOTELS OF HAWAII' },
  { id: '3787', name: '3787 - CARIBE ROYALE RESORTS' },
  { id: '3788', name: '3788 - ALA MOANA HOTEL' },
  { id: '3789', name: '3789 - SMUGGLER’S NOTCH RESORT' },
  { id: '3790', name: '3790 - RAFFLES HOTELS' },
  { id: '3791', name: '3791 - STAYBRIDGE SUITES' },
  { id: '3792', name: '3792 - CLARIDGE CASINO HOTEL' },
  { id: '3793', name: '3793 - FLAMINGO HOTELS' },
  { id: '3794', name: '3794 - GRAND CASINO HOTELS' },
  { id: '3795', name: '3795 - PARIS LAS VEGAS HOTEL' },
  { id: '3796', name: '3796 - PEPPERMILL HOTEL CASINO' },
  { id: '3797', name: '3797 - ATLANTIC CITY HILTON RESORTS' },
  { id: '3798', name: '3798 - EMBASSY VACATION RESORT' },
  { id: '3799', name: '3799 - HALE KOA HOTEL' },
  { id: '3800', name: '3800 - HOMESTEAD SUITES' },
  { id: '3801', name: '3801 - WILDERNESS HOTEL AND RESORT' },
  { id: '3802', name: '3802 - THE PALACE HOTEL' },
  { id: '3807', name: '3807 - ELEMENT' },
  { id: '3808', name: '3808 - LXR' },
  { id: '3811', name: '3811 - PREMIER INN' },
  { id: '3812', name: '3812 - HYATT PLACE' },
  { id: '3813', name: '3813 - HOTEL INDIGO' },
  { id: '3814', name: '3814 - THE ROOSEVELT HOTEL NY' },
  { id: '3815', name: '3815 - NICKELODEON FAMILY SUITES BY HOLIDAY INN' },
  { id: '3816', name: '3816 - Home2Suites' },
  { id: '3818', name: '3818 - MAINSTAY SUITES' },
  { id: '3819', name: '3819 - OXFORD SUITES' },
  { id: '3820', name: '3820 - JUMEIRAH ESSEX HOUSE' },
  { id: '3821', name: '3821 - CARIBE ROYALE' },
  { id: '3822', name: '3822 - CROSSLAND' },
  { id: '3823', name: '3823 - GRAND SIERRA RESORT' },
  { id: '3824', name: '3824 - ARIA' },
  { id: '3825', name: '3825 - VDARA' },
  { id: '3826', name: '3826 - AUTOGRAPH' },
  { id: '3827', name: '3827 - GALT HOUSE' },
  { id: '3828', name: '3828 - COSMOPOLITAN OF LAS VEGAS' },
  { id: '3829', name: '3829 - COUNTRY INN BY RADISSON' },
  { id: '3830', name: '3830 - PARK PLAZA HOTEL' },
  { id: '3831', name: '3831 - WALDORF' },
  { id: '3832', name: '3832 - CURIO HOTELS' },
  { id: '3833', name: '3833 - CANOPY' },
  { id: '3834', name: '3834 - BAYMONT INN & SUITES' },
  { id: '3835', name: '3835 - * MASTERS ECONOMY INNS' },
  { id: '3836', name: '3836 - HAWTHORN BY WYNDHAM' },
  { id: '3837', name: '3837 - HOSHINO RESORTS' },
  { id: '3838', name: '3838 - KIMPTON HOTELS' },
  { id: '3839', name: '3839 - KYORITSU HOTELS' },
  { id: '3840', name: '3840 - RIO HOTELS' },
  { id: '3841', name: '3841 - TRIBUTE PORTFOLIO' },
  { id: '3842', name: '3842 - MARRIOT EXECUTIVE APARTMENTS' },
  { id: '3843', name: '3843 - MOXY' },
  { id: '3844', name: '3844 - AC HOTELS' },
  { id: '3845', name: '3845 - BULGARI' },
  { id: '3846', name: '3846 - THE LUXURY COLLECTION' },
  { id: '3847', name: '3847 - JW MARRIOT' },
  { id: '3848', name: '3848 - EDITION' },
  { id: '3849', name: '3849 - MINACIA' },
  { id: '3850', name: '3850 - BREEZBAY GROUP' },
  { id: '3851', name: '3851 - CANDEO HOTELS' },
  { id: '3852', name: '3852 - CORE GLOBAL MANAGEMENT HOTELS AND RESORTS' },
  { id: '3853', name: '3853 - GRANBELL HOTELS AND RESORTS' },
  { id: '3854', name: '3854 - JHAT' },
  { id: '3855', name: '3855 - C\'EST LA VIE RESORT IZUMIGO' },
  { id: '3856', name: '3856 - BANYAN TREE HOTELS & RESORTS' },
  { id: '3857', name: '3857 - HOTEL SUNROUTE' },
  { id: '3858', name: '3858 - SOTETSU FRESA-INN' },
  { id: '3859', name: '3859 - LA VISTA' },
  { id: '3860', name: '3860 - JR-EAST HOTEL METS' },
  { id: '3861', name: '3861 - AB HOTEL' },
  { id: '3862', name: '3862 - CHISUN HOTELS' },
  { id: '3863', name: '3863 - SUPER HOTEL' },
  { id: '3864', name: '3864 - ITOEN HOTEL' },
  { id: '3865', name: '3865 - QUINTESSA HOTEL' },
  { id: '3866', name: '3866 - SMILE HOTEL' },
  { id: '3867', name: '3867 - HOTEL ALPHA-1' },
  { id: '3868', name: '3868 - RELO VACATIONS' },
  { id: '3869', name: '3869 - YUTORELO' },
  { id: '3870', name: '3870 - KEIO PRESSO INN' },
  { id: '3871', name: '3871 - VILLA-FONTAINE' },
  { id: '3872', name: '3872 - MEITETSU INN' },
  { id: '3873', name: '3873 - TOKYU HARVEST CLUB' },
  { id: '3874', name: '3874 - HOTEL LIVEMAX' },
  { id: '3875', name: '3875 - FUFU JAPAN' },
  { id: '3876', name: '3876 - HMI HOTEL GROUP' },
  { id: '3877', name: '3877 - ORIX HOTELS & RESORTS' },
  { id: '3878', name: '3878 - WASHINGTON HOTEL' },
  { id: '3879', name: '3879 - SANCO INN' },
  { id: '3880', name: '3880 - HOTEL UNIZO' },
  { id: '3881', name: '3881 - HOTEL METROPOLITAN' },
  { id: '3882', name: '3882 - CENTURION HOTELS' },
  { id: '3883', name: '3883 - NEST HOTEL' },
  { id: '4011', name: '4011 - Railroads' },
  { id: '4111', name: '4111 - Local/Suburban Commuter Passenger Transportation - Railroads, Feries, Local Water Transportation.' },
  { id: '4112', name: '4112 - Passenger Railways' },
  { id: '4119', name: '4119 - Ambulance Services' },
  { id: '4121', name: '4121 - Taxicabs and Limousines' },
  { id: '4131', name: '4131 - Bus Lines, Including Charters, Tour Buses' },
  { id: '4214', name: '4214 - Motor Freight Carriers and Trucking - Local and Long Distance, Moving and Storage Companies, and Local Delivery' },
  { id: '4215', name: '4215 - Courier Services - Air and Ground, and Freight Forwarders' },
  { id: '4225', name: '4225 - Public Warehousing and Storage - Farm Products, Refrigerated Goods, Household Goods, and Storage' },
  { id: '4411', name: '4411 - Cruise and Steamship Lines' },
  { id: '4457', name: '4457 - Boat Rentals and Leasing' },
  { id: '4468', name: '4468 - Marinas, Marine Service, and Supplies' },
  { id: '4511', name: '4511 - Airlines and Air Carriers (Not Elsewhere Classified)' },
  { id: '4582', name: '4582 - Airports, Flying Fields, and Airport Terminals' },
  { id: '4722', name: '4722 - Travel Agencies and Tour Operations' },
  { id: '4723', name: '4723 - Package Tour Operators (for use in Germany only)' },
  { id: '4784', name: '4784 - Tolls and Bridge Fees' },
  { id: '4789', name: '4789 - Transportation Services (Not Elsewhere Classified)' },
  { id: '4812', name: '4812 - Telecommunications Equipment including telephone sales' },
  { id: '4814', name: '4814 - Telecommunication Services, including Local and Long-Distance Calls, Credit Card Calls, Calls Through Use of Magnetic-' },
  { id: '4815', name: '4815 - VisaPhone' },
  { id: '4816', name: '4816 - Computer Network/Information Services' },
  { id: '4821', name: '4821 - Telegraph services' },
  { id: '4829', name: '4829 - Money Orders - Wire Transfer' },
  { id: '4899', name: '4899 - Cable, Satellite and Other Pay Television/Radio/Streaming Services' },
  { id: '4900', name: '4900 - Utilities - Electric, Gas, Water, and Sanitary' },
  { id: '5013', name: '5013 - Motor vehicle supplies and new parts' },
  { id: '5021', name: '5021 - Office and Commercial Furniture' },
  { id: '5039', name: '5039 - Construction Materials (Not Elsewhere Classified)' },
  { id: '5044', name: '5044 - Photographic, Photocopy, Microfilm Equipment and Supplies' },
  { id: '5045', name: '5045 - Computers and Computer Peripheral Equipment and Software' },
  { id: '5046', name: '5046 - Commercial Equipment (Not Elsewhere Classified)' },
  { id: '5047', name: '5047 - Medical, Dental, Ophthalmic and Hospital Equipment and Supplies' },
  { id: '5051', name: '5051 - Metal Service Centers and Offices' },
  { id: '5065', name: '5065 - Electrical Parts and Equipment' },
  { id: '5072', name: '5072 - Hardware, Equipment and Supplies' },
  { id: '5074', name: '5074 - Plumbing and Heating Equipment and Supplies' },
  { id: '5085', name: '5085 - Industrial Supplies (Not Elsewhere Classified)' },
  { id: '5094', name: '5094 - Precious Stones and Metals, Watches and Jewelry' },
  { id: '5099', name: '5099 - Durable Goods (Not Elsewhere Classified)' },
  { id: '5111', name: '5111 - Stationery, Office Supplies, Printing, and Writing Paper' },
  { id: '5122', name: '5122 - Drugs, Drug Proprietors, and Druggist\'s Sundries' },
  { id: '5131', name: '5131 - Piece Goods, Notions, and Other Dry Goods' },
  { id: '5137', name: '5137 - Men’s, Women’s, and Children’s Uniforms and Commercial Clothing' },
  { id: '5139', name: '5139 - Commercial Footwear' },
  { id: '5169', name: '5169 - Chemicals and Allied Products (Not Elsewhere Classified)' },
  { id: '5172', name: '5172 - Petroleum and Petroleum Products' },
  { id: '5192', name: '5192 - Books, Periodicals, and Newspapers' },
  { id: '5193', name: '5193 - Florists\' Supplies, Nursery Stock and Flowers' },
  { id: '5198', name: '5198 - Paints, Varnishes, and Supplies' },
  { id: '5199', name: '5199 - Nondurable Goods (Not Elsewhere Classified)' },
  { id: '5200', name: '5200 - Home Supply Warehouse Stores' },
  { id: '5211', name: '5211 - Lumber and Building Materials Stores' },
  { id: '5231', name: '5231 - Glass, Paint, and Wallpaper Stores' },
  { id: '5251', name: '5251 - Hardware Stores' },
  { id: '5261', name: '5261 - Nurseries and Lawn and Garden Supply Stores' },
  { id: '5262', name: '5262 - Marketplaces' },
  { id: '5271', name: '5271 - Mobile Home Dealers' },
  { id: '5300', name: '5300 - Wholesale Clubs' },
  { id: '5309', name: '5309 - Duty Free Stores' },
  { id: '5310', name: '5310 - Discount Stores' },
  { id: '5311', name: '5311 - Department Stores' },
  { id: '5331', name: '5331 - Variety Stores' },
  { id: '5399', name: '5399 - Miscellaneous General Merchandise' },
  { id: '5411', name: '5411 - Grocery Stores, Supermarkets' },
  { id: '5422', name: '5422 - Meat Provisioners - Freezer and Locker' },
  { id: '5441', name: '5441 - Candy, Nut, and Confectionery Stores' },
  { id: '5451', name: '5451 - Dairy Products Stores' },
  { id: '5462', name: '5462 - Bakeries' },
  { id: '5499', name: '5499 - Miscellaneous Food Stores - Convenience Stores and Specialty Markets' },
  { id: '5511', name: '5511 - Car and Truck Dealers (New and Used) Sales, Service, Repairs, Parts, and Leasing' },
  { id: '5521', name: '5521 - Car and Truck Dealers (Used Only) Sales, Service, Repairs, Parts, and Leasing' },
  { id: '5531', name: '5531 - Automobile Supply Stores' },
  { id: '5532', name: '5532 - Automotive Tire Stores' },
  { id: '5533', name: '5533 - Automotive Parts, Accessories Stores' },
  { id: '5541', name: '5541 - Service Stations (with or without ancillary services)' },
  { id: '5542', name: '5542 - Automated Fuel Dispensers' },
  { id: '5551', name: '5551 - Boat Dealers' },
  { id: '5552', name: '5552 - Electric Vehicle Charging' },
  { id: '5561', name: '5561 - Camper, Recreational and Utility Trailer Dealers' },
  { id: '5571', name: '5571 - Motorcycle Shops and Dealers' },
  { id: '5592', name: '5592 - Motor Homes Dealers' },
  { id: '5598', name: '5598 - Snowmobile Dealers' },
  { id: '5599', name: '5599 - Miscellaneous Automotive, Aircraft, and Farm Equipment Dealers (Not Elsewhere Classified)' },
  { id: '5611', name: '5611 - Men\'s and Boy\'s Clothing and Accessories Stores' },
  { id: '5621', name: '5621 - Women\'s Ready-to-Wear Stores' },
  { id: '5631', name: '5631 - Women\'s Accessory and Specialty Shops' },
  { id: '5641', name: '5641 - Children\'s and Infant\'s Wear Stores' },
  { id: '5651', name: '5651 - Family Clothing Stores' },
  { id: '5655', name: '5655 - Sports Apparel, Riding Apparel Stores' },
  { id: '5661', name: '5661 - Shoe Stores' },
  { id: '5681', name: '5681 - Furriers and Fur Shops' },
  { id: '5691', name: '5691 - Men\'s and Women\'s Clothing Stores' },
  { id: '5697', name: '5697 - Tailors, Seamstresses, Mending, and Alterations' },
  { id: '5698', name: '5698 - Wig and Toupee Stores' },
  { id: '5699', name: '5699 - Miscellaneous Apparel and Accessory Shops' },
  { id: '5712', name: '5712 - Furniture, Home Furnishings, and Equipment Stores, Except Appliances' },
  { id: '5713', name: '5713 - Floor Covering Stores' },
  { id: '5714', name: '5714 - Drapery, Window Covering, and Upholstery Stores' },
  { id: '5718', name: '5718 - Fireplace, Fireplace Screens, and Accessories Stores' },
  { id: '5719', name: '5719 - Miscellaneous Home Furnishing Specialty Stores' },
  { id: '5722', name: '5722 - Household Appliance Stores' },
  { id: '5723', name: '5723 - Guns and Ammunition Shops' },
  { id: '5732', name: '5732 - Electronics Stores' },
  { id: '5733', name: '5733 - Music Stores - Musical Instruments, Pianos, and Sheet Music' },
  { id: '5734', name: '5734 - Computer Software Stores' },
  { id: '5735', name: '5735 - Record Stores' },
  { id: '5811', name: '5811 - Caterers' },
  { id: '5812', name: '5812 - Eating places and Restaurants' },
  { id: '5813', name: '5813 - Drinking Places (Alcoholic Beverages) - Bars, Taverns, Nightclubs, Cocktail Lounges, and Discotheques' },
  { id: '5814', name: '5814 - Fast Food Restaurants' },
  { id: '5815', name: '5815 - Digital Goods Media - Books, Movies, Digital artwork/images, Music' },
  { id: '5816', name: '5816 - Digital Goods - Games' },
  { id: '5817', name: '5817 - Digital Goods - Applications (Excludes Games)' },
  { id: '5818', name: '5818 - Digital Goods - Large Digital Goods Merchant' },
  { id: '5832', name: '5832 - Antique Shops - Sales, Repairs, and Restoration Services' },
  { id: '5912', name: '5912 - Drug Stores and Pharmacies' },
  { id: '5921', name: '5921 - Package Stores - Beer, Wine, and Liquor' },
  { id: '5931', name: '5931 - Used Merchandise and Secondhand Stores' },
  { id: '5932', name: '5932 - Antique Shops - Sales, Repairs, and Restoration Services' },
  { id: '5933', name: '5933 - Pawn Shops and Salvage Yards' },
  { id: '5935', name: '5935 - Wrecking and Salvage Yards' },
  { id: '5937', name: '5937 - Antique Reproductions' },
  { id: '5940', name: '5940 - Bicycle Shops - Sales and Service' },
  { id: '5941', name: '5941 - Sporting Goods Stores' },
  { id: '5942', name: '5942 - Book Stores' },
  { id: '5943', name: '5943 - Stationery Stores, Office and School Supply Stores' },
  { id: '5944', name: '5944 - Jewelry Stores, Watches, Clocks, and Silverware Stores' },
  { id: '5945', name: '5945 - Hobby, Toy, and Game Shops' },
  { id: '5946', name: '5946 - Camera and Photographic Supply Stores' },
  { id: '5947', name: '5947 - Card Shops, Gift, Novelty, and Souvenir Shops' },
  { id: '5948', name: '5948 - Luggage and Leather Goods Stores' },
  { id: '5949', name: '5949 - Sewing, Needlework, Fabric and Piece Goods Stores' },
  { id: '5950', name: '5950 - Glassware/Crystal Stores' },
  { id: '5960', name: '5960 - Direct Marketing - Insurance Services' },
  { id: '5961', name: '5961 - Mail Order Houses Including Catalog Order Stores, Book/Record Clubs (No longer permitted for U.S. original presentments)' },
  { id: '5962', name: '5962 - Direct Marketing - Travel Related Arrangements Services' },
  { id: '5963', name: '5963 - Door-to-Door Sales' },
  { id: '5964', name: '5964 - Direct Marketing - Catalog Merchant' },
  { id: '5965', name: '5965 - Direct Marketing - Catalog and Catalog and Retail Merchant' },
  { id: '5966', name: '5966 - Direct Marketing - Outbound Telemarketing Merchant' },
  { id: '5967', name: '5967 - Direct Marketing - Inbound Teleservices Merchant' },
  { id: '5968', name: '5968 - Direct Marketing - Continuity/Subscription Merchant' },
  { id: '5969', name: '5969 - Direct Marketing - Other Direct Marketers (Not Elsewhere Classified)' },
  { id: '5970', name: '5970 - Artist\'s Supply and Craft Shops' },
  { id: '5971', name: '5971 - Art Dealers and Galleries' },
  { id: '5972', name: '5972 - Stamp and Coin Stores - Philatelic and Numismatic Supplies' },
  { id: '5973', name: '5973 - Religious Goods Stores' },
  { id: '5975', name: '5975 - Hearing Aids - Sales, Service, and Supply Stores' },
  { id: '5976', name: '5976 - Orthopedic Goods - Prosthetic Devices' },
  { id: '5977', name: '5977 - Cosmetic Stores' },
  { id: '5978', name: '5978 - Typewriter Stores - Sales, Rentals, and Service' },
  { id: '5983', name: '5983 - Fuel Dealers - Fuel Oil, Wood, Coal, and Liquefied Petroleum' },
  { id: '5992', name: '5992 - Florists' },
  { id: '5993', name: '5993 - Cigar Stores and Stands' },
  { id: '5994', name: '5994 - News Dealers and Newsstands' },
  { id: '5995', name: '5995 - Pet Shops, Pet Foods, and Supplies Stores' },
  { id: '5996', name: '5996 - Swimming Pools - Sales, Service, and Supplies' },
  { id: '5997', name: '5997 - Electric Razor Stores - Sales and Service' },
  { id: '5998', name: '5998 - Tent and Awning Shops' },
  { id: '5999', name: '5999 - Miscellaneous and Specialty Retail Stores' },
  { id: '6010', name: '6010 - Financial Institutions - Manual Cash Disbursements' },
  { id: '6011', name: '6011 - Financial Institutions - Automated Cash Disbursements' },
  { id: '6012', name: '6012 - Financial Institutions - Merchandise, Services, and Debt Repayment' },
  { id: '6051', name: '6051 - Non-Financial Institutions - Foreign Currency, Liquid and Cryptocurrency Assets (for example: Cryptocurrency), Money' },
  { id: '6211', name: '6211 - Security Brokers/Dealers' },
  { id: '6300', name: '6300 - Insurance Sales, Underwriting, and Premiums' },
  { id: '6381', name: '6381 - Insurance Premiums, (no longer valid for first presentment work)' },
  { id: '6399', name: '6399 - Insurance Not Elsewhere Classified (no longer valid forfirst presentment work)' },
  { id: '6513', name: '6513 - Real Estate Agents and Managers - Rentals' },
  { id: '6540', name: '6540 - Non-Financial Institutions - Stored Value Card Purchase/Load' },
  { id: '7011', name: '7011 - Lodging - Hotels, Motels, Resorts, Central Reservation Services (Not Elsewhere Classified)' },
  { id: '7012', name: '7012 - Timeshares' },
  { id: '7032', name: '7032 - Sporting and Recreational Camps' },
  { id: '7033', name: '7033 - Trailer Parks and Camp Grounds' },
  { id: '7210', name: '7210 - Laundry, Cleaning, and Garment Services' },
  { id: '7211', name: '7211 - Laundries - Family and Commercial' },
  { id: '7216', name: '7216 - Dry Cleaners' },
  { id: '7217', name: '7217 - Carpet and Upholstery Cleaning' },
  { id: '7221', name: '7221 - Photographic Studios' },
  { id: '7230', name: '7230 - Barber and Beauty Shops' },
  { id: '7251', name: '7251 - Shop Repair Shops and Shoe Shine Parlors, and Hat Cleaning Shops' },
  { id: '7261', name: '7261 - Funeral Services and Crematories' },
  { id: '7273', name: '7273 - Dating and Escort Services' },
  { id: '7276', name: '7276 - Tax Preparation Services' },
  { id: '7277', name: '7277 - Counseling Services - Debt, Marriage, and Personal' },
  { id: '7278', name: '7278 - Buying and Shopping Services and Clubs' },
  { id: '7296', name: '7296 - Clothing Rental - Costumes, Formal Wear, Uniforms' },
  { id: '7297', name: '7297 - Massage Parlors' },
  { id: '7298', name: '7298 - Health and Beauty Shops' },
  { id: '7299', name: '7299 - Miscellaneous Personal Services (Not Elsewhere Classified)' },
  { id: '7311', name: '7311 - Advertising Services' },
  { id: '7321', name: '7321 - Consumer Credit Reporting Agencies' },
  { id: '7322', name: '7322 - Collection Agencies' },
  { id: '7332', name: '7332 - Blueprinting and Photocopying Services' },
  { id: '7333', name: '7333 - Commercial Photography, Art, and Graphics' },
  { id: '7338', name: '7338 - Quick Copy, Reproduction, and Blueprinting Services' },
  { id: '7339', name: '7339 - Stenographic and Secretarial Support Services' },
  { id: '7342', name: '7342 - Exterminating and Disinfecting Services' },
  { id: '7349', name: '7349 - Cleaning, Maintenance, and Janitorial Services' },
  { id: '7361', name: '7361 - Employment Agencies, Temporary Help Services' },
  { id: '7372', name: '7372 - Computer Programming, Data Processing, and Integrated Systems Design Services' },
  { id: '7375', name: '7375 - Information Retrieval Services' },
  { id: '7379', name: '7379 - Computer Maintenance, Repair and Services (Not Elsewhere Classified)' },
  { id: '7392', name: '7392 - Management, Consulting, and Public Relations Services' },
  { id: '7393', name: '7393 - Detective Agencies, Protective Services, and Security Services, including Armored Cars, and Guard Dogs' },
  { id: '7394', name: '7394 - Equipment Rental and Leasing Services, Tool Rental, Furniture Rental, and Appliance Rental' },
  { id: '7395', name: '7395 - Photofinishing Laboratories, Photo Developing' },
  { id: '7399', name: '7399 - Business Services (Not Elsewhere Classified)' },
  { id: '7511', name: '7511 - Truck Stop' },
  { id: '7512', name: '7512 - Car Rental Companies Not Listed Below' },
  { id: '7513', name: '7513 - Truck and Utility Trailer Rentals' },
  { id: '7519', name: '7519 - Motor Home and Recreational Vehicle Rentals' },
  { id: '7523', name: '7523 - Parking Lots, Parking Meters and Garages' },
  { id: '7531', name: '7531 - Automotive Body Repair Shops' },
  { id: '7534', name: '7534 - Tire Re-treading and Repair Shops' },
  { id: '7535', name: '7535 - Paint Shops - Automotive' },
  { id: '7538', name: '7538 - Automotive Service Shops (Non-Dealer)' },
  { id: '7542', name: '7542 - Car Washes' },
  { id: '7549', name: '7549 - Towing Services' },
  { id: '7622', name: '7622 - Electronics Repair Shops' },
  { id: '7623', name: '7623 - Air Conditioning and Refrigeration Repair Shops' },
  { id: '7629', name: '7629 - Electrical And Small Appliance Repair Shops' },
  { id: '7631', name: '7631 - Watch, Clock, and Jewelry Repair' },
  { id: '7641', name: '7641 - Furniture, Furniture Repair, and Furniture Refinishing' },
  { id: '7692', name: '7692 - Welding Services' },
  { id: '7699', name: '7699 - Repair Shops and Related Services -Miscellaneous' },
  { id: '7800', name: '7800 - Government-Owned Lotteries (US Region only)' },
  { id: '7801', name: '7801 - Government Licensed On-Line Casinos (On-Line Gambling) (US Region only)' },
  { id: '7802', name: '7802 - Government-Licensed Horse/Dog Racing (US Region only)' },
  { id: '7829', name: '7829 - Motion Pictures and Video Tape Production and Distribution' },
  { id: '7832', name: '7832 - Motion Picture Theaters' },
  { id: '7841', name: '7841 - DVD/Video Tape Rental Stores' },
  { id: '7911', name: '7911 - Dance Halls, Studios and Schools' },
  { id: '7922', name: '7922 - Ticket Agencies and Theatrical Producers (Except Motion Pictures)' },
  { id: '7929', name: '7929 - Bands, Orchestras, and Miscellaneous Entertainers (Not Elsewhere Classified)' },
  { id: '7932', name: '7932 - Billiard and Pool Establishments' },
  { id: '7933', name: '7933 - Bowling Alleys' },
  { id: '7941', name: '7941 - Commercial Sports, Professional Sports Clubs, Athletic Fields, and Sports Promoters' },
  { id: '7991', name: '7991 - Tourist Attractions and Exhibits' },
  { id: '7992', name: '7992 - Golf Courses - Public' },
  { id: '7993', name: '7993 - Video Amusement Game Supplies' },
  { id: '7994', name: '7994 - Video Game Arcades/Establishments' },
  { id: '7995', name: '7995 - Betting, including Lottery Tickets, Casino Gaming Chips, Off-Track Betting, Wagers at Race Tracks and games of chance to' },
  { id: '7996', name: '7996 - Amusement Parks, Circuses, Carnivals, and Fortune Tellers' },
  { id: '7997', name: '7997 - Membership Clubs (Sports, Recreation, Athletic), Country Clubs, and Private Golf Courses' },
  { id: '7998', name: '7998 - Aquariums, Seaquariums, Dolphinariums, and Zoos' },
  { id: '7999', name: '7999 - Recreation Services (Not Elsewhere Classified)' },
  { id: '8011', name: '8011 - Doctors and Physicians (Not Elsewhere Classified)' },
  { id: '8021', name: '8021 - Dentists and Orthodontists' },
  { id: '8031', name: '8031 - Osteopaths' },
  { id: '8041', name: '8041 - Chiropractors' },
  { id: '8042', name: '8042 - Optometrists and Ophthalmologists' },
  { id: '8043', name: '8043 - Opticians, Opticians Goods and Eyeglasses' },
  { id: '8044', name: '8044 - Opticians, Optical Goods, and Eyeglasses (no longer valid for first presentments)' },
  { id: '8049', name: '8049 - Podiatrists and Chiropodists' },
  { id: '8050', name: '8050 - Nursing, Home Healthcare and Personal Care Facilities' },
  { id: '8062', name: '8062 - Hospitals' },
  { id: '8071', name: '8071 - Medical and Dental Laboratories' },
  { id: '8099', name: '8099 - Medical Services and Health Practitioners (Not Elsewhere Classified)' },
  { id: '8111', name: '8111 - Legal Services and Attorneys' },
  { id: '8211', name: '8211 - Elementary and Secondary Schools' },
  { id: '8220', name: '8220 - Colleges, Universities, Professional Schools, and Junior Colleges' },
  { id: '8241', name: '8241 - Correspondence Schools' },
  { id: '8244', name: '8244 - Business and Secretarial Schools' },
  { id: '8249', name: '8249 - Vocational Schools and Trade Schools' },
  { id: '8299', name: '8299 - Schools and Educational Services (Not Elsewhere Classified)' },
  { id: '8351', name: '8351 - Child Care Services' },
  { id: '8398', name: '8398 - Charitable and Social Service Organizations' },
  { id: '8641', name: '8641 - Civic, Fraternal, and Social Associations' },
  { id: '8651', name: '8651 - Political Organizations' },
  { id: '8661', name: '8661 - Religious Organizations' },
  { id: '8675', name: '8675 - Automobile Associations' },
  { id: '8699', name: '8699 - Membership Organizations (Not Elsewhere Classified)' },
  { id: '8734', name: '8734 - Testing Laboratories (Non-Medical Testing)' },
  { id: '8911', name: '8911 - Architectural, Engineering, and Surveying Services' },
  { id: '8931', name: '8931 - Accounting, Auditing, and Bookkeeping Services' },
  { id: '8999', name: '8999 - Professional Services (Not Elsewhere Classified)' },
  { id: '9211', name: '9211 - Court Costs, including Alimony and Child Support' },
  { id: '9222', name: '9222 - Fines' },
  { id: '9223', name: '9223 - Bail and Bond Payments' },
  { id: '9311', name: '9311 - Tax Payments' },
  { id: '9399', name: '9399 - Government Services (Not Elsewhere Classified)' },
  { id: '9402', name: '9402 - Postal Services - Government Only' },
  { id: '9405', name: '9405 - U.S. Federal Government Agencies or Departments' },
  { id: '9406', name: '9406 - Government-Owned Lotteries (Non-U.S. region)' },
  { id: '9700', name: '9700 - Automated Referral Service (For Visa Only)' },
  { id: '9701', name: '9701 - Visa Credential Service (For Visa Only)' },
  { id: '9702', name: '9702 - Emergency Services (GCAS) (Visa use only)' },
  { id: '9950', name: '9950 - Intra - Company Purchases (For Visa Only)' },
];

export default merchantCategoryCode;
